// @ts-nocheck
/* eslint-disable */
import React, { useMemo, useCallback, useRef, useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { useCalculationsSelector } from '../store/selectors/calculations';
import useAppStore from '../store/appStore';
import useAdminStore from '../store/adminStore';
import { EmployeeData, Geraet } from '../store/types';
import { isSoloModeActive } from '../utils/soloMode';
import PreislistenManager from '../components/PreislistenManager';
import PaketpreisModal, { clearPaketpreisDraft, emptyPaketpreisDraft, loadLetzterPaketTitel, loadPaketpreisDraft, rememberPaketTitel, savePaketpreisDraft } from '../components/kalkulator/PaketpreisModal';
import { berechneRuecklage } from '../utils/paketRuecklage';
import BeratungsZeitKostenSuite from '../components/kalkulator/BeratungsZeitKostenSuite'; 

const CustomStyles = () => (
    <style>{`
      :root { 
          --custom-beige: #E6C299;
          --slate-800: #1e293b;
          --slate-900: #0f172a;
          --slate-700: #334155;
      }
      .text-customBeige { color: var(--custom-beige); text-shadow: 0 0 2px rgba(0,0,0,0.5); }
      .bg-customBeige { background-color: var(--custom-beige); }
      .border-customBeige { border-color: var(--custom-beige); }
      
      body { 
          font-family: 'Inter', sans-serif;
          color: #f9fafb; 
          background-color: #030303; 
      }
      
      .font-numeric {
          font-family: 'JetBrains Mono', monospace;
          font-variant-numeric: tabular-nums;
      }

      .editable-field { 
          background: linear-gradient(145deg, #000000, #0a0a0a);
          color: white; 
          border: 1px solid #222;
          border-radius: 0.5rem; 
          padding: 0.5rem; 
          text-align: center; 
          cursor: text; 
          min-width: 60px; 
          width: 100%;
          box-sizing: border-box;
          font-family: 'JetBrains Mono', monospace;
          transition: all 0.2s;
          box-shadow: inset 2px 2px 5px rgba(0,0,0,0.8), inset -1px -1px 2px rgba(255,255,255,0.05);
          -webkit-appearance: none;
          appearance: none;
      }
      .editable-field:focus { 
          outline: none;
          border-color: var(--custom-beige);
          box-shadow: 0 0 10px rgba(230, 194, 153, 0.2); 
      }
      .editable-field[data-placeholder]:empty::before { content: attr(data-placeholder); color: #475569; pointer-events: none; }

      .step-field-wrap {
          display: flex;
          align-items: center;
          gap: 0.25rem;
          width: 100%;
          min-width: 0;
          min-height: 2.25rem;
      }
      .step-field-wrap .editable-field {
          flex: 1 1 auto;
          min-width: 0;
          align-self: center;
      }
      .step-btn {
          flex: 0 0 auto;
          width: 2rem;
          min-width: 2rem;
          height: 2.25rem;
          min-height: 2.25rem;
          padding: 0;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          background: linear-gradient(145deg, #111, #000);
          color: var(--custom-beige);
          border: 1px solid #222;
          border-radius: 0.5rem;
          font-size: 1.05rem;
          font-weight: 800;
          line-height: 1;
          cursor: pointer;
          user-select: none;
          -webkit-tap-highlight-color: transparent;
          touch-action: manipulation;
          box-shadow: 2px 2px 5px rgba(0,0,0,0.5), -1px -1px 2px rgba(255,255,255,0.05);
          transition: all 0.15s;
      }
      .step-btn:hover {
          border-color: var(--custom-beige);
          color: #000;
          background: var(--custom-beige);
      }
      .step-btn:active {
          transform: scale(0.94);
          box-shadow: inset 2px 2px 5px rgba(0,0,0,0.5);
      }
      .step-field-compact .step-btn {
          width: 1.65rem;
          min-width: 1.65rem;
          height: 2rem;
          min-height: 2rem;
          font-size: 0.95rem;
      }
      .step-field-compact.step-field-wrap {
          min-height: 2rem;
      }
      @media (min-width: 640px) {
          .step-btn {
              width: 2.25rem;
              min-width: 2.25rem;
              height: 2.5rem;
              min-height: 2.5rem;
              font-size: 1.15rem;
          }
          .step-field-wrap {
              gap: 0.35rem;
              min-height: 2.5rem;
          }
          .step-field-compact .step-btn {
              width: 2rem;
              min-width: 2rem;
              height: 2.35rem;
              min-height: 2.35rem;
          }
          .step-field-compact.step-field-wrap {
              min-height: 2.35rem;
          }
      }
      
      .calculated-field {
          background: rgba(0,0,0,0.4);
          color: var(--custom-beige);
          border-radius: 0.5rem;
          text-align: center;
          width: 100%;
          font-family: 'JetBrains Mono', monospace; 
          padding: 0.5rem;
          font-weight: 600;
          border: 1px solid #1a1a1a;
          box-shadow: inset 0 2px 10px rgba(0,0,0,0.5);
      }

      input[type="checkbox"] { 
          -webkit-appearance: none; 
          appearance: none; 
          background-color: #000000; 
          border: 1px solid #333; 
          border-radius: 0.25rem; 
          width: 1.25rem; 
          height: 1.25rem; 
          cursor: pointer; 
          position: relative; 
          vertical-align: middle; 
          box-shadow: inset 0 0 5px rgba(0,0,0,1); 
      }
      input[type="checkbox"]:checked { 
          background-color: var(--custom-beige); 
          border-color: var(--custom-beige); 
          box-shadow: 0 0 10px var(--custom-beige); 
      }
      input[type="checkbox"]:checked::after { 
          content: '✔'; 
          position: absolute; 
          color: #000; 
          font-size: 0.8rem; 
          font-weight: bold; 
          top: 50%; 
          left: 50%; 
          transform: translate(-50%, -50%); 
      }

      .action-btn { 
          background: linear-gradient(145deg, #111, #000);
          color: #E6C299; 
          padding: 0.25rem 0.75rem; 
          border-radius: 0.375rem; 
          border: 1px solid #222; 
          transition: all 0.2s; 
          white-space: nowrap;
          box-shadow: 2px 2px 5px rgba(0,0,0,0.5), -1px -1px 2px rgba(255,255,255,0.05);
      }
      .action-btn:hover { 
          background: #E6C299; 
          color: #000;
          transform: translateY(-1px); 
          box-shadow: 0 0 10px rgba(230,194,153,0.3); 
      }
      .action-btn:active { 
          transform: translateY(1px); 
          box-shadow: inset 2px 2px 5px rgba(0,0,0,0.5); 
      }
      
      .remove-btn { 
          background-color: #111; 
          color: #64748b; 
          border-radius: 0.375rem; 
          width: 1.75rem; 
          height: 1.75rem; 
          border: 1px solid #222; 
          cursor: pointer; 
          display: flex; 
          align-items: center; 
          justify-content: center; 
          transition: all 0.2s; 
      }
      .remove-btn:hover { 
          background-color: #ef4444; 
          color: white;
          border-color: #ef4444;
          box-shadow: 0 0 8px #ef4444; 
      }

      .custom-select { 
          background-color: #000000; 
          color: var(--custom-beige); 
          border-radius: 0.5rem; 
          padding: 0.5rem; 
          border: 1px solid #222; 
          cursor: pointer; 
          box-shadow: inset 0 0 5px rgba(0,0,0,1); 
      }

      /* Carbon Weave Design */
      .carbon-weave-bg {
          background-color: #111;
          background-image:
              radial-gradient(circle at 100% 150%, #111 24%, #1a1a1a 24%, #1a1a1a 28%, #111 28%, #111 36%, #1a1a1a 36%, #1a1a1a 40%, transparent 40%, transparent),
              radial-gradient(circle at 0 150%, #111 24%, #1a1a1a 24%, #1a1a1a 28%, #111 28%, #111 36%, #1a1a1a 36%, #1a1a1a 40%, transparent 40%, transparent),
              radial-gradient(circle at 50% 100%, #1a1a1a 10%, #111 10%, #111 23%, #1a1a1a 23%, #1a1a1a 30%, #111 30%, #111 43%, #1a1a1a 43%, #1a1a1a 50%, #111 50%, #111 63%, #1a1a1a 63%, #1a1a1a 71%, transparent 71%, transparent),
              radial-gradient(circle at 100% 50%, #1a1a1a 5%, #111 5%, #111 15%, #1a1a1a 15%, #1a1a1a 20%, #111 20%, #111 29%, #1a1a1a 29%, #1a1a1a 34%, #111 34%, #111 44%, #1a1a1a 44%, #1a1a1a 49%, transparent 49%, transparent),
              radial-gradient(circle at 0 50%, #1a1a1a 5%, #111 5%, #111 15%, #1a1a1a 15%, #1a1a1a 20%, #111 20%, #111 29%, #1a1a1a 29%, #1a1a1a 34%, #111 34%, #111 44%, #1a1a1a 44%, #1a1a1a 49%, transparent 49%, transparent);
          background-size: 20px 20px;
      }

      .carbon-panel {
          position: relative;
          border-radius: 1.5rem;
          border: 1px solid #1a1a1a;
          box-shadow: 0 30px 60px -15px rgba(0,0,0,1), inset 0 2px 5px rgba(255,255,255,0.02);
          overflow: hidden;
          z-index: 1;
      }

      .carbon-panel::after {
          content: '';
          position: absolute;
          inset: 0;
          background: linear-gradient(to bottom, transparent, rgba(0,0,0,0.55));
          pointer-events: none;
          z-index: 1;
      }

      .carbon-content {
          position: relative;
          z-index: 10;
      }

      .gauge-container-3d {
          background: radial-gradient(circle at center, #111 0%, #030303 100%);
          box-shadow: inset 0 0 40px rgba(0,0,0,0.95), 0 10px 25px rgba(0,0,0,0.6);
          border: 1px solid #1a1a1a;
          border-radius: 1.5rem;
          padding-top: 0.5rem;
          padding-bottom: 0.5rem;
      }

      .text-verlust { color: #ef4444 !important; text-shadow: 0 0 15px rgba(239, 68, 68, 0.6) !important; }
      .text-kostendeckend { color: #facc15; text-shadow: 0 0 15px rgba(250, 204, 21, 0.6) !important; }
      .text-gewinn { color: #22c55e; text-shadow: 0 0 15px rgba(34, 197, 94, 0.6) !important; }
      .text-gut { color: #3b82f6; text-shadow: 0 0 15px rgba(59, 130, 246, 0.6) !important; }
      .text-exzellent { color: #8b5cf6; text-shadow: 0 0 15px rgba(139, 92, 246, 0.6) !important; }

      .anpassung-ok { color: #60a5fa; }
      .anpassung-moderate { color: #fbbf24; }
      .anpassung-critical { color: #f87171; }

      .pe-gauge-value { text-shadow: 0 2px 4px rgba(0,0,0,0.5); }
      .pe-gauge-status { text-shadow: 0 0 10px currentColor; }
      
      circle#gewinn-gauge-progress { transition: stroke-dashoffset 0.8s cubic-bezier(0.4, 0, 0.2, 1), stroke 0.5s ease-in-out; }
      .compact-table th, .compact-table td { padding: 0.5rem 0.75rem; font-size: 0.85rem; border-bottom: 1px solid #1a1a1a; vertical-align: middle;}
      .compact-table th { background-color: rgba(0,0,0,0.5); color: var(--custom-beige); text-transform: uppercase; letter-spacing: 0.05em; border-bottom: 1px solid #222; }

      .modal-input {
          width: 100%;
          background: rgba(0,0,0,0.8);
          border: 1px solid #222;
          color: white;
          padding: 0.75rem;
          border-radius: 0.5rem;
          margin-top: 0.5rem;
      }
      .modal-input:focus { outline: none; border-color: var(--custom-beige); }

      /* Tooltip system */
      [data-tooltip-id] { position: relative; }
      .pe-tooltip { background-color: var(--custom-beige); color: black; border: 1px solid white; font-weight: 700; border-radius: 0.25rem; padding: 0.5rem; position: fixed; z-index: 2147483647; display: none; font-size: 0.8rem; max-width: 250px; box-shadow: 0 10px 20px rgba(0,0,0,0.6); pointer-events: none; }
      .pe-tooltip.visible { display: block; }

      /* ===== LIGHT-MODE OVERRIDES (Warm-Platin) — Dark bleibt via html.dark unangetastet ===== */
      html:not(.dark) body {
          color: var(--pe-text-primary);
          background-color: var(--pe-bg-primary);
      }
      html:not(.dark) .text-customBeige { color: var(--pe-accent-text); text-shadow: none; }
      html:not(.dark) .editable-field {
          background: var(--pe-bg-input);
          color: var(--pe-text-primary);
          border-color: var(--pe-border-strong);
          box-shadow: inset 0 1px 3px rgba(28,25,23,0.1);
      }
      html:not(.dark) .editable-field[data-placeholder]:empty::before { color: #A8A29E; }
      html:not(.dark) .step-btn {
          background: var(--pe-bg-card);
          color: var(--pe-accent-text);
          border-color: var(--pe-border-strong);
          box-shadow: 0 1px 2px rgba(28,25,23,0.08);
      }
      html:not(.dark) .step-btn:hover {
          background: var(--pe-accent-text);
          color: #fff;
          border-color: var(--pe-accent-text);
      }
      html:not(.dark) .calculated-field {
          background: var(--pe-bg-tile-header);
          color: var(--pe-accent-text);
          border-color: var(--pe-border-subtle);
          box-shadow: inset 0 1px 3px rgba(28,25,23,0.08);
      }
      html:not(.dark) input[type="checkbox"] {
          background-color: var(--pe-bg-input);
          border-color: var(--pe-border-strong);
          box-shadow: inset 0 0 2px rgba(28,25,23,0.2);
      }
      html:not(.dark) .action-btn {
          background: var(--pe-bg-card);
          color: var(--pe-accent-text);
          border-color: var(--pe-border-strong);
          box-shadow: 0 1px 3px rgba(28,25,23,0.12);
      }
      html:not(.dark) .remove-btn {
          background-color: var(--pe-bg-tile-header);
          color: #78716C;
          border-color: var(--pe-border-subtle);
      }
      html:not(.dark) .custom-select {
          background-color: var(--pe-bg-input);
          color: var(--pe-accent-text);
          border-color: var(--pe-border-strong);
          box-shadow: inset 0 1px 3px rgba(28,25,23,0.1);
      }
      html:not(.dark) .carbon-weave-bg {
          background-color: var(--pe-bg-elevated);
          background-image: none;
      }
      html:not(.dark) .carbon-panel {
          border-color: var(--pe-border-subtle);
          box-shadow: 0 20px 45px -20px rgba(28, 25, 23, 0.18), 0 2px 8px rgba(28, 25, 23, 0.06);
      }
      html:not(.dark) .carbon-panel::after { background: none; }
      html:not(.dark) .gauge-container-3d {
          background: var(--pe-bg-elevated);
          box-shadow: inset 0 1px 4px rgba(28,25,23,0.08), 0 4px 12px rgba(28,25,23,0.08);
          border-color: var(--pe-border-subtle);
      }
      html:not(.dark) .text-verlust { color: #B91C1C !important; text-shadow: none !important; }
      html:not(.dark) .text-kostendeckend { color: #A16207 !important; text-shadow: none !important; }
      html:not(.dark) .text-gewinn { color: #15803D !important; text-shadow: none !important; }
      /* Blau-Status muss auf Platin dunkel genug sein — Pastell (#60a5fa) ist unleserlich */
      html:not(.dark) .text-gut { color: #1E3A8A !important; text-shadow: none !important; }
      html:not(.dark) .text-exzellent { color: #5B21B6 !important; text-shadow: none !important; }

      html:not(.dark) .anpassung-ok { color: #1E3A8A; }
      html:not(.dark) .anpassung-moderate { color: #B45309; }
      html:not(.dark) .anpassung-critical { color: #B91C1C; }

      html:not(.dark) .pe-gauge-value,
      html:not(.dark) .pe-gauge-status { text-shadow: none !important; }

      /* Tailwind-Pastelltöne → kontrastreiche Light-Farben */
      html:not(.dark) .text-blue-400 { color: #1E3A8A !important; }
      html:not(.dark) .text-green-400 { color: #15803D !important; }
      html:not(.dark) .text-red-400 { color: #B91C1C !important; }
      html:not(.dark) .text-orange-400 { color: #C2410C !important; }
      html:not(.dark) .text-yellow-500 { color: #A16207 !important; }
      html:not(.dark) .text-stone-500 { color: #44403C !important; }
      html:not(.dark) .text-gray-500 { color: #44403C !important; }
      html:not(.dark) .text-gray-600 { color: #57534E !important; }
      html:not(.dark) .text-slate-500 { color: #44403C !important; }

      html:not(.dark) .gauge-container-3d.pe-gauge-light {
          box-shadow: 0 2px 10px rgba(28, 25, 23, 0.12) !important;
          background: var(--pe-bg-card) !important;
      }

      html:not(.dark) .compact-table th, html:not(.dark) .compact-table td { border-bottom-color: var(--pe-border-subtle); }
      html:not(.dark) .compact-table th { background-color: var(--pe-bg-tile-header); color: var(--pe-accent-text); border-bottom-color: var(--pe-border-subtle); }
      html:not(.dark) .modal-input {
          background: var(--pe-bg-input);
          border-color: var(--pe-border-strong);
          color: var(--pe-text-primary);
      }

@media print {
          .no-print-container { display: none !important; height: 0 !important; overflow: hidden !important; }
      }
    `}</style>
);

const parseNumber = (text: any): number => {
    if (text === null || text === undefined) return 0;
    let s = String(text).replace(/<[^>]*>/g, ' ').replace(/\u00a0/g, ' ').trim();
    const hasComma = s.includes(',');
    const hasDot = s.includes('.');
    if (hasDot && hasComma && s.lastIndexOf('.') < s.lastIndexOf(',')) { 
        s = s.replace(/\./g, '').replace(',', '.'); 
    } else if (hasComma) { 
        s = s.replace(',', '.'); 
    }
    const cleaned = s.replace(/[^0-9.-]/g, '');
    const number = parseFloat(cleaned);
    return isNaN(number) ? 0 : number;
};

const formatMinutes = (num: number): string => `${isNaN(num) ? 0 : num.toLocaleString('de-DE')} min`;
const formatGramm = (num: number): string => `${isNaN(num) ? 0 : num.toLocaleString('de-DE')} g`;
const formatPercent = (num: number, digits: number = 1): string => isNaN(num) ? '0,0%' : num.toLocaleString('de-DE', { minimumFractionDigits: digits, maximumFractionDigits: digits }) + '%';

const symbolToText = (formattedValue: string): string => {
    return formattedValue.replace('€', 'EUR').replace('CHF', 'CHF');
};

const EditableField = ({ value, onSave, format, className, placeholder, type = "number", readOnly = false, formatCurrency }: any) => {
    const [draft, setDraft] = useState('');
    const [focused, setFocused] = useState(false);
    const inputRef = useRef<HTMLInputElement>(null);

    const formatValue = useCallback((val: any, fmt: string) => {
        const numVal = parseNumber(val);
        switch(fmt) {
            case 'currency': {
                const formatted = formatCurrency ? formatCurrency(numVal) : `${numVal.toLocaleString('de-DE', {minimumFractionDigits: 2, maximumFractionDigits: 2})} EUR`;
                return symbolToText(formatted);
            }
            case 'minutes': return formatMinutes(numVal);
            case 'gramm': return formatGramm(numVal);
            case 'percent': return formatPercent(numVal, 1);
            default: return String(val ?? '');
        }
    }, [formatCurrency]);

    const displayValue = type === 'text'
        ? String(value ?? '')
        : formatValue(value, format);

    useEffect(() => {
        if (!focused) setDraft(displayValue);
    }, [displayValue, focused]);

    if (readOnly) {
        return <div className={`calculated-field ${className || ''}`}>{displayValue}</div>;
    }

    const commit = (raw: string) => {
        if (type === 'text') {
            onSave(raw);
            setDraft(raw);
            return;
        }
        const numValue = parseNumber(raw);
        onSave(numValue);
        setDraft(formatValue(numValue, format));
    };

    const handleFocus = (e: React.FocusEvent<HTMLInputElement>) => {
        setFocused(true);
        const editVal = type === 'text'
            ? String(value ?? '')
            : String(parseNumber(value)).replace('.', ',');
        setDraft(editVal);
        // Markierung nach Fokus — auch auf Touch-Geräten
        requestAnimationFrame(() => {
            try { e.target.select(); } catch { /* ignore */ }
        });
    };

    const handleBlur = () => {
        setFocused(false);
        commit(draft);
    };

    const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            e.currentTarget.blur();
        }
    };

    // Mobil: manches „Fertig“ feuert change, ohne zuverlässiges Enter
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setDraft(e.target.value);
    };

    // Minuten meist ganzzahlig → numeric; Geld/Gramm/% → decimal (Komma möglich)
    const mobileInputMode =
        type === 'text' ? 'text'
        : format === 'minutes' ? 'numeric'
        : 'decimal';

    return (
        <input
            ref={inputRef}
            type="text"
            inputMode={mobileInputMode}
            enterKeyHint="done"
            autoComplete="off"
            autoCorrect="off"
            autoCapitalize="off"
            spellCheck={false}
            lang="de-DE"
            value={focused ? draft : displayValue}
            placeholder={placeholder || ''}
            className={`editable-field ${className || ''}`}
            onFocus={handleFocus}
            onBlur={handleBlur}
            onChange={handleChange}
            onKeyDown={handleKeyDown}
        />
    );
};

/** Kompakter +/- Stepper um EditableField — mobil-taugliche Touch-Ziele, Optik wie Kalkulator-Inputs. */
const SteppedEditableField = ({
    value,
    onSave,
    step = 5,
    min = 0,
    format,
    className,
    formatCurrency,
    ariaLabel,
    compact = false,
}: {
    value: number;
    onSave: (v: number) => void;
    step?: number;
    min?: number;
    format?: string;
    className?: string;
    formatCurrency?: (v: number, d?: number) => string;
    ariaLabel?: string;
    compact?: boolean;
}) => {
    const nudge = (dir: -1 | 1) => {
        const cur = Number(value);
        const base = Number.isFinite(cur) ? cur : 0;
        let next: number;
        if (step >= 1) {
            const rem = ((base % step) + step) % step;
            const isAligned = rem < 0.01 || step - rem < 0.01;
            if (!isAligned) {
                next = dir > 0 ? Math.ceil(base / step) * step : Math.floor(base / step) * step;
            } else {
                next = Math.round((base + dir * step) / step) * step;
            }
        } else {
            next = Math.round((base + dir * step) * 100) / 100;
        }
        if (next < min) next = min;
        onSave(next);
    };

    return (
        <div className={`step-field-wrap${compact ? ' step-field-compact' : ''}`}>
            <button
                type="button"
                className="step-btn"
                aria-label={`${ariaLabel || 'Wert'} verringern`}
                onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    nudge(-1);
                }}
            >
                −
            </button>
            <EditableField
                value={value}
                onSave={onSave}
                format={format}
                className={className}
                formatCurrency={formatCurrency}
            />
            <button
                type="button"
                className="step-btn"
                aria-label={`${ariaLabel || 'Wert'} erhöhen`}
                onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    nudge(1);
                }}
            >
                +
            </button>
        </div>
    );
};

const NagModal = ({ stundenfaktor, targetMatPreis, onConfirmMatch, onSaveCustomRates, onClose, formatCurrency }: any) => {
    const [editMode, setEditMode] = useState(false);
    const [tempBase, setTempBase] = useState(stundenfaktor);
    const [tempMat, setTempMat] = useState(targetMatPreis);

    return (
        <div className="fixed inset-0 bg-stone-900/50 dark:bg-black/85 flex items-center justify-center z-[2000000] p-4 backdrop-blur-md">
            <div className="bg-pe-card p-8 rounded-2xl shadow-[0_0_40px_rgba(230,194,153,0.15)] border border-customBeige/50 w-full max-w-lg relative animate-in fade-in zoom-in duration-300">
                <button onClick={onClose} className="absolute top-4 right-4 text-stone-500 dark:text-gray-500 hover:text-pe-text transition-colors text-xl" title="Minimieren">✕</button>
                
                <div className="flex items-center gap-3 mb-6 border-b border-pe-border dark:border-[#222] pb-4">
                    <span className="text-3xl drop-shadow-[0_0_10px_rgba(230,194,153,0.5)]">⚠️</span>
                    <h2 className="text-2xl font-bold text-customBeige tracking-wide">Strategie-Check</h2>
                </div>
                
                {!editMode ? (
                    <>
                        <p className="text-pe-muted dark:text-gray-300 mb-6 text-lg leading-relaxed">
                            Dein Betreuer hat dir folgende Basis-Werte für deine Preiskalkulation empfohlen:
                        </p>
                        
                        <div className="bg-pe-sunken p-5 rounded-xl border border-pe-border dark:border-[#222] mb-6 space-y-4 shadow-inner">
                            <div className="flex justify-between items-center">
                                <span className="text-pe-muted dark:text-gray-400 font-bold uppercase tracking-wider text-sm">Ohne Material:</span>
                                <span className="text-2xl font-black font-numeric text-pe-text">{symbolToText(formatCurrency(stundenfaktor))}</span>
                            </div>
                            <div className="flex justify-between items-center pt-3 border-t border-[#1a1a1a]">
                                <span className="text-yellow-600/90 font-bold uppercase tracking-wider text-sm">Inkl. Material:</span>
                                <span className="text-2xl font-black font-numeric text-yellow-500">{symbolToText(formatCurrency(targetMatPreis))}</span>
                            </div>
                        </div>

                        <p className="text-pe-muted dark:text-gray-300 font-medium mb-6">
                            Hast du diese Werte in deiner Preisliste aktualisiert und arbeitest du damit?
                        </p>

                        <div className="flex flex-col gap-3">
                            <button
                                onClick={onConfirmMatch}
                                className="action-btn !font-bold py-3 text-lg transition-all border border-[#E6C299]"
                                style={{ color: '#ffffff', background: '#1a1a1a' }}
                            >
                                ✅ Ja, ich nutze exakt diese Werte!
                            </button>
                            <button
                                onClick={() => setEditMode(true)}
                                className="action-btn py-3 transition-all border border-pe-border-strong"
                                style={{ color: '#ffffff', background: '#111111' }}
                            >
                                ❌ Nein, meine IST-Werte weichen ab.
                            </button>
                            <button onClick={onClose} className="text-pe-muted dark:text-gray-400 hover:text-pe-text text-sm mt-3 underline decoration-gray-700 underline-offset-4">
                                Fenster minimieren (Später eintragen)
                            </button>
                        </div>
                    </>
                ) : (
                    <div className="animate-in fade-in slide-in-from-right-4">
                        <p className="text-customBeige font-bold mb-4 text-lg leading-relaxed">
                            ✏️ Trage hier deine echten, aktuellen Werte ein:
                        </p>
                        
                        <div className="bg-pe-sunken p-5 rounded-xl border border-customBeige/50 mb-6 space-y-4 shadow-inner">
                            <div className="flex justify-between items-center">
                                <span className="text-pe-muted dark:text-gray-400 font-bold uppercase tracking-wider text-sm">Dein echter Wert<br/>(Ohne Material):</span>
                                <EditableField 
                                    value={tempBase} 
                                    onSave={setTempBase} 
                                    format="currency" 
                                    className="min-w-[120px] !bg-pe-input dark:!bg-black !text-pe-text dark:!text-white !font-black !text-2xl !p-2 border border-pe-border-strong focus:border-customBeige" 
                                    formatCurrency={formatCurrency} 
                                />
                            </div>
                            <div className="flex justify-between items-center pt-3 border-t border-[#1a1a1a]">
                                <span className="text-yellow-600/90 font-bold uppercase tracking-wider text-sm">Dein echter Wert<br/>(Inkl. Material):</span>
                                <EditableField 
                                    value={tempMat} 
                                    onSave={setTempMat} 
                                    format="currency" 
                                    className="min-w-[120px] !bg-pe-input dark:!bg-black !text-yellow-700 dark:!text-yellow-500 !font-black !text-2xl !p-2 border border-yellow-600/50 focus:border-yellow-500" 
                                    formatCurrency={formatCurrency} 
                                />
                            </div>
                        </div>
                        
                        <button 
                            onClick={() => onSaveCustomRates(tempBase, tempMat)} 
                            className="w-full action-btn !bg-customBeige !text-black !font-black py-4 text-lg hover:!bg-white shadow-[0_0_20px_rgba(230,194,153,0.4)] transition-all"
                        >
                            Werte speichern & Check abschließen
                        </button>
                        <button onClick={() => setEditMode(false)} className="w-full text-center text-stone-500 dark:text-gray-500 hover:text-gray-300 text-sm mt-4 underline decoration-gray-700 underline-offset-4">
                            Zurück
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
};

const PreislisteModal = ({ onClose, onSave, calc, inputs, geraeteData }: any) => {
    const [name, setName] = useState('');
    const [kategorie, setKategorie] = useState('Damen');
    const [customKat, setCustomKat] = useState('');
    const [matDesc, setMatDesc] = useState('');

    const hasMat = calc.totalMaterialCost > 0;
    const hasDev = calc.totalActivatedDevicePrice > 0;
    
    const initialDevDesc = hasDev && geraeteData ? geraeteData.map((g:any) => g.desc).join(' + ') : '';
    const [devDesc, setDevDesc] = useState(initialDevDesc);

    const preDifs = ['Damen', 'Herren', 'Farbe', 'Strähnen', 'Kosmetik', 'Dauerwelle', 'Spezial', 'Custom'];

    const handleSave = () => {
        if (!name.trim()) return alert('Bitte einen Namen vergeben.');
        const finalKat = kategorie === 'Custom' ? customKat : kategorie;
        if (!finalKat.trim()) return alert('Bitte eine Kategorie angeben.');

        onSave({
            name,
            kategorie: finalKat,
            bedienzeit: inputs.bedienzeit,
            materialEinsatz: calc.totalMaterialCost,
            materialMenge: inputs.materialGramm,
            materialBeschreibung: hasMat ? matDesc : undefined,
            geräteEinsatz: calc.totalActivatedDevicePrice,
            geräteBeschreibung: hasDev ? devDesc : undefined,
            finalerPreis: inputs.neuerPreis,
            preisProStunde: inputs.bedienzeit > 0 ? (inputs.neuerPreis / inputs.bedienzeit) * 60 : 0
        });
    };

    return (
        <div className="fixed inset-0 bg-stone-900/50 dark:bg-black/80 flex items-center justify-center z-[1000000] p-4 backdrop-blur-sm pt-20">
            <div className="bg-pe-card p-6 sm:p-8 rounded-2xl shadow-2xl border border-pe-border dark:border-[#222] w-full max-w-md max-h-[85vh] overflow-y-auto">
                <h2 className="text-2xl font-bold text-customBeige mb-6 border-b border-pe-border dark:border-[#222] pb-2">In Preisliste aufnehmen</h2>
                
                <div className="space-y-4">
                    <div>
                        <label className="text-sm text-pe-muted dark:text-gray-400 font-semibold">Leistungsname</label>
                        <input type="text" value={name} onChange={e => setName(e.target.value)} placeholder="z.B. Ansatzfarbe" className="modal-input" autoFocus />
                    </div>

                    <div>
                        <label className="text-sm text-pe-muted dark:text-gray-400 font-semibold">Kategorie</label>
                        <select value={kategorie} onChange={e => setKategorie(e.target.value)} className="modal-input custom-select w-full mt-2">
                            {preDifs.map(k => <option key={k} value={k}>{k === 'Custom' ? 'Eigene Kategorie...' : k}</option>)}
                        </select>
                    </div>

                    {kategorie === 'Custom' && (
                        <div className="animate-fade-in">
                            <label className="text-sm text-pe-muted dark:text-gray-400 font-semibold">Eigene Kategorie</label>
                            <input type="text" value={customKat} onChange={e => setCustomKat(e.target.value)} placeholder="Name der Kategorie" className="modal-input" />
                        </div>
                    )}

                    {hasMat && (
                        <div className="bg-[#1a1a00] p-3 rounded-lg border border-yellow-700/30 mt-4">
                            <label className="text-sm text-yellow-500 font-semibold flex items-center gap-2"><span>🧪</span> Material-Label für Druck (Optional)</label>
                            <input type="text" value={matDesc} onChange={e => setMatDesc(e.target.value)} placeholder="z.B. inkl. Farb- & Pflegeprodukte" className="modal-input !border-yellow-700/50 focus:!border-yellow-500" />
                            <p className="text-xs text-pe-muted dark:text-gray-400 mt-2">Kundenfreundlicher Sammelbegriff für die gedruckte Liste.</p>
                        </div>
                    )}

                    {hasDev && (
                        <div className="bg-[#000a1a] p-3 rounded-lg border border-blue-700/30 mt-4">
                            <label className="text-sm text-blue-400 font-semibold flex items-center gap-2"><span>🔌</span> Geräte-Label für Druck (Optional)</label>
                            <input type="text" value={devDesc} onChange={e => setDevDesc(e.target.value)} placeholder="z.B. inkl. Trockenhaube" className="modal-input !border-blue-700/50 focus:!border-blue-500" />
                            <p className="text-xs text-pe-muted dark:text-gray-400 mt-2">Das verwendete Gerät, das auf der Preisliste stehen soll.</p>
                        </div>
                    )}
                </div>

                <div className="flex gap-4 mt-8">
                    <button onClick={onClose} className="w-1/3 action-btn !bg-transparent hover:!bg-[#222]">Abbrechen</button>
                    <button onClick={handleSave} className="w-2/3 action-btn !bg-customBeige !text-black !font-bold hover:!bg-white" style={{ background: '#E6C299' }}>Speichern</button>
                </div>
            </div>
        </div>
    );
};

const BeratungsBarometerModal = (props: {
    stundenfaktor: number;
    kalkRuecklage: number;
    storeCalc: any;
    formatCurrency: (v: number, d?: number) => string;
    initialDemoRate?: number;
    effectiveSozialabgabenPercent?: number;
    materialData?: any[];
    activeMaterialIDs?: string[] | Set<string>;
    onToggleMaterial?: (id: string) => void;
    initialMaterialGramm?: number;
    onClose: () => void;
}) => {
    const activeIds = Array.isArray(props.activeMaterialIDs)
        ? props.activeMaterialIDs
        : props.activeMaterialIDs
          ? Array.from(props.activeMaterialIDs)
          : [];
    return (
        <BeratungsZeitKostenSuite
            stundenfaktor={props.stundenfaktor}
            kalkRuecklage={props.kalkRuecklage}
            storeCalc={props.storeCalc}
            formatCurrency={props.formatCurrency}
            initialDemoRate={props.initialDemoRate}
            effectiveSozialabgabenPercent={props.effectiveSozialabgabenPercent}
            materialData={props.materialData}
            activeMaterialIDs={activeIds}
            onToggleMaterial={props.onToggleMaterial}
            initialMaterialGramm={props.initialMaterialGramm}
            onClose={props.onClose}
        />
    );
};

const PreisBarometer = ({ 
    stundenfaktor, kalkRuecklage, formatCurrency, adminParamData, showGeraeteSection, onOpenAdmin,
    useEchterStundensatz, setUseEchterStundensatz, echterStundensatz, setEchterStundensatz,
    useEchterStundensatzMat, setUseEchterStundensatzMat, echterStundensatzMat, setEchterStundensatzMat,
    baseMatParam, targetMatPreis, targetMatRuecklage, hasConfirmedRates, onTriggerNag, onResetConfirmation,
    baseMatGrams, storeCalc, // 💉 FIX: storeCalc für exakte Berechnungen hinzugefügt
    isGodMode = false,
    onOpenBeratungsBarometer,
}: any) => { 
    const [customMinutes, setCustomMinutes] = useState(35);
    const [customMatMinutes, setCustomMatMinutes] = useState(35);
    // Mittelteil nur im God-Mode einklappbar; Mandant sieht immer alles
    const [isDetailsVisible, setIsDetailsVisible] = useState(true);

    useEffect(() => {
        if (!isGodMode) setIsDetailsVisible(true);
    }, [isGodMode]);
    
    // 💉 FIX: Exaktes Reverse-Engineering der Kostenstruktur (wie im PreislistenManager)
    const mwst = (storeCalc?.mwstSatz !== undefined && storeCalc?.mwstSatz !== null ? Number(storeCalc.mwstSatz) : 19) / 100;
    const gk = storeCalc?.gemeinkostenfaktor || 0;
    // Kanonisch: Anteil am Netto-Monatsumsatz (wie Selektor unprodUnternehmerlohnPercent)
    const ul = (storeCalc?.unprodUnternehmerlohnPercent || 0) / 100;
    const vl = (storeCalc?.settings?.global?.Verlust_1 || 0) / 100;
    const propRate = gk + ul + vl;
    const nettoMultiplier = 1 - propRate;

    // --- Basis Stundensatz Logic ---
    const activeStundenfaktor = useEchterStundensatz && echterStundensatz > 0 ? echterStundensatz : stundenfaktor;
    const diff = (echterStundensatz || 0) - stundenfaktor;
    const minutenPreis = useMemo(() => (activeStundenfaktor > 0 ? activeStundenfaktor / 60 : 0), [activeStundenfaktor]);
    
    // Fixkosten ermitteln basierend auf der Empfehlung (Soll)
    const targetNettoBase = stundenfaktor / (1 + mwst);
    const targetGewinnBase = targetNettoBase * (kalkRuecklage / 100);
    const fixedCostsBase = (targetNettoBase * nettoMultiplier) - targetGewinnBase;

    // Wahre IST-Marge berechnen (berücksichtigt gesunkene/gestiegene proportionale Kosten)
    const istNettoBase = (echterStundensatz || 0) / (1 + mwst);
    const istGewinnBase = (istNettoBase * nettoMultiplier) - fixedCostsBase;
    const realProfitMargin = istNettoBase > 0 ? (istGewinnBase / istNettoBase) * 100 : 0;
    
    // --- Inklusive Material Logic ---
    const activeStundenfaktorMat = useEchterStundensatzMat && echterStundensatzMat > 0 ? echterStundensatzMat : targetMatPreis;
    const diffMat = (echterStundensatzMat || 0) - targetMatPreis;

    // Fixkosten inkl. Material ermitteln basierend auf der Empfehlung (Soll)
    const targetNettoMat = targetMatPreis / (1 + mwst);
    const targetGewinnMat = targetNettoMat * (targetMatRuecklage / 100);
    const fixedCostsMat = (targetNettoMat * nettoMultiplier) - targetGewinnMat;

    // Wahre IST-Marge inkl. Material berechnen
    const istNettoMat = (echterStundensatzMat || 0) / (1 + mwst);
    const istGewinnMat = (istNettoMat * nettoMultiplier) - fixedCostsMat;
    const realProfitMarginMat = istNettoMat > 0 ? (istGewinnMat / istNettoMat) * 100 : 0;

    const matMinutenPreis = activeStundenfaktorMat > 0 ? activeStundenfaktorMat / 60 : 0;

    const timeSlots = [10, 15, 20, 30, 40, 45, 50]; 
    const updateDatum = new Date().toLocaleDateString('de-DE'); 
    
    const fmtEUR = (val: number) => symbolToText(formatCurrency(val));

    const showBaseToggle = !(hasConfirmedRates && !useEchterStundensatz);
    const showMatToggle = baseMatParam && !(hasConfirmedRates && !useEchterStundensatzMat);

    const handleToggleEchterStundensatz = (e: React.ChangeEvent<HTMLInputElement>) => {
        const isChecked = e.target.checked;
        setUseEchterStundensatz(isChecked);
        if (isChecked && (!echterStundensatz || echterStundensatz === 0)) {
            setEchterStundensatz(stundenfaktor);
        }
        if (!isChecked) {
            if (onResetConfirmation) onResetConfirmation();
            if (onTriggerNag) onTriggerNag();
        }
    };

    const handleToggleEchterStundensatzMat = (e: React.ChangeEvent<HTMLInputElement>) => {
        const isChecked = e.target.checked;
        setUseEchterStundensatzMat(isChecked);
        if (isChecked && (!echterStundensatzMat || echterStundensatzMat === 0)) {
            setEchterStundensatzMat(targetMatPreis);
        }
        if (!isChecked) {
            if (onResetConfirmation) onResetConfirmation();
            if (onTriggerNag) onTriggerNag();
        }
    };

    // Tooltip Texte für die IST-Rücklagen-Warnungen
    const warningTooltipBasis = diff < 0 
        ? `⚠️ Strategie-Warnung: Dein Preis erwirtschaftet nur noch ${formatPercent(realProfitMargin)} Rücklage (Ziel: ${formatPercent(kalkRuecklage)}).` 
        : diff > 0 
        ? `✅ Starkes Pricing: Du überbietest das Ziel und erwirtschaftest ${formatPercent(realProfitMargin)} Rücklage!` 
        : `Information: Dein IST-Wert entspricht exakt der Empfehlung.`;

    const warningTooltipMat = diffMat < 0 
        ? `⚠️ Warnung (Material): Dein Preis erwirtschaftet nur noch ${formatPercent(realProfitMarginMat)} Rücklage (Ziel: ${formatPercent(targetMatRuecklage)}).` 
        : diffMat > 0 
        ? `✅ Starkes Pricing: Du überbietest das Ziel und erwirtschaftest ${formatPercent(realProfitMarginMat)} Rücklage!` 
        : `Information: Dein IST-Wert entspricht exakt der Empfehlung.`;

    return ( 
        <section id="preis-barometer-section" className="relative carbon-panel carbon-weave-bg carbon-surface p-4 sm:p-6 w-full"> 
            <div className="carbon-content">
                <div className="flex items-center justify-between gap-2 border-b border-pe-border dark:border-[#222] pb-2 mb-6">
                    <h2 className="text-lg sm:text-2xl font-semibold text-customBeige min-w-0 truncate pr-1">Preis-Barometer</h2>
                    <div className="flex items-center gap-1 shrink-0">
                        {isGodMode && typeof onOpenBeratungsBarometer === 'function' && (
                            <button
                                type="button"
                                onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    onOpenBeratungsBarometer();
                                }}
                                className="w-9 h-9 sm:w-10 sm:h-10 bg-pe-sunken/80 dark:bg-black/50 border border-customBeige/40 rounded-full flex items-center justify-center cursor-pointer text-customBeige text-base hover:border-customBeige hover:bg-customBeige/10 transition-all shadow-sm"
                                title="Beratungs-Barometer (manueller Stundensatz)"
                                aria-label="Beratungs-Barometer öffnen"
                            >
                                🎯
                            </button>
                        )}
                        {isGodMode && (
                            <button
                                type="button"
                                onClick={() => setIsDetailsVisible((v) => !v)}
                                className="w-9 h-9 sm:w-10 sm:h-10 bg-pe-sunken/80 dark:bg-black/50 border border-customBeige/30 rounded-full flex items-center justify-center cursor-pointer text-customBeige text-sm font-bold hover:border-customBeige hover:bg-customBeige/10 transition-all shadow-sm"
                                title={isDetailsVisible ? 'Details einklappen (God-Mode)' : 'Details ausklappen (God-Mode)'}
                                aria-label={isDetailsVisible ? 'Details einklappen' : 'Details ausklappen'}
                            >
                                {isDetailsVisible ? '▾' : '▸'}
                            </button>
                        )}
                        <button
                            type="button"
                            onClick={onOpenAdmin}
                            className="w-9 h-9 sm:w-10 sm:h-10 bg-transparent border border-transparent rounded-full opacity-40 hover:opacity-100 sm:opacity-20 sm:hover:opacity-100 transition-opacity flex items-center justify-center cursor-pointer"
                            title="Admin-PIN / Parameter"
                            aria-label="Admin-PIN"
                        >
                            <span className="text-lg sm:text-xl">🔒</span>
                        </button>
                    </div>
                </div>
                
                {/* Zweier-Spalte erst ab lg — Tablet/schmal sonst zu eng neben Sidebar */}
                <div className="grid grid-cols-1 lg:grid-cols-2 text-lg flex-grow"> 
                    
                    {/* --- LINKE SPALTE (BASIS) --- */}
                    <div className="flex flex-col lg:border-r lg:border-[#222] lg:pr-10 mb-6 lg:mb-0"> 
                        <div className="flex-grow space-y-3">
                            {/* Empfehlung Basis — kompakt, Farben lesbar */}
                            <div className="bg-pe-tile-header px-2.5 py-2 rounded-lg border border-customBeige/40 shadow-inner relative overflow-hidden mb-2">
                                <div className="absolute top-0 left-0 w-0.5 h-full bg-customBeige"></div>
                                <div className="font-bold text-[10px] text-customBeige mb-1 uppercase tracking-wider pl-2">
                                    Wir empfehlen dir den Stundenfaktor
                                </div> 
                                <div className="flex justify-between items-center pl-2 gap-2"> 
                                    <div>
                                        <span className="font-numeric text-pe-text text-xs block leading-none">60 min. (Soll)</span> 
                                        <span className="text-[10px] font-semibold block mt-0.5 text-blue-400 leading-none">
                                            Ziel-Rücklage: {formatPercent(kalkRuecklage)}
                                        </span>
                                    </div>
                                    <span className="text-pe-text font-bold text-base font-numeric">{fmtEUR(stundenfaktor)}</span> 
                                </div> 
                            </div>

                            {/* Toggle für Basis Stundensatz */}
                            {showBaseToggle && (
                                <div className="py-2 space-y-4 animate-fade-in">
                                    <div>
                                        <label className="flex items-start gap-3 cursor-pointer mb-2">
                                            <input 
                                                type="checkbox" 
                                                checked={useEchterStundensatz} 
                                                onChange={handleToggleEchterStundensatz} 
                                                className="mt-0.5" 
                                            />
                                            <span className="text-sm text-pe-muted dark:text-gray-300 font-bold leading-tight mt-0.5">Mein echter Salon-Stundensatz weicht ab</span>
                                        </label>

                                        {/* 💉 BOX 2: IST-WERT (Kompakt mit Tooltip) */}
                                        {useEchterStundensatz && (
                                            <div 
                                                className="bg-pe-sunken p-3 rounded-xl border border-pe-border dark:border-[#222] shadow-inner animate-in fade-in slide-in-from-top-2 cursor-help" 
                                                data-tooltip-id="app-tooltip" 
                                                data-tooltip-content={warningTooltipBasis}
                                            >
                                                <div className="font-black text-xs text-pe-muted dark:text-gray-400 mb-1.5 uppercase tracking-widest">
                                                    Dein echter Stundenfaktor (IST)
                                                </div>
                                                <div className="flex justify-between items-center mb-1.5">
                                                    <div>
                                                        <span className="font-numeric text-pe-muted dark:text-gray-300 text-base block leading-none">60 min. (Soll)</span> 
                                                        <span className={`text-[11px] font-bold block mt-1 leading-none ${diff < 0 ? 'text-red-400' : 'text-blue-400'}`}>
                                                            IST-Rücklage: {formatPercent(realProfitMargin)}
                                                        </span>
                                                    </div>
                                                    <EditableField 
                                                        value={echterStundensatz} 
                                                        onSave={setEchterStundensatz} 
                                                        format="currency" 
                                                        className="min-w-[120px] !bg-pe-input dark:!bg-black !text-customBeige !font-black !text-lg !py-1 !px-2 border border-customBeige shadow-[0_0_10px_rgba(230,194,153,0.2)]" 
                                                        formatCurrency={formatCurrency} 
                                                    />
                                                </div>
                                                <div className="flex justify-between items-center mt-2">
                                                    <span className="text-[11px] text-customBeige">✏️ IST-Wert eintragen</span>
                                                    <span className={`text-[11px] font-bold ${diff > 0 ? 'text-green-400' : diff < 0 ? 'text-orange-400' : 'text-stone-500 dark:text-gray-500'}`}>
                                                        {diff !== 0 ? `${diff > 0 ? '▲' : '▼'} ${fmtEUR(Math.abs(diff))}` : 'Entspricht Empfehlung'}
                                                    </span>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            )}

                            {/* Berechnungsgrundlage Basis Liste — einklappbar nur God-Mode */}
                            {isDetailsVisible && (
                            <div>
                                <div className="font-bold text-sm text-pe-muted dark:text-gray-400 mb-2 mt-4 uppercase tracking-wider">Basis Berechnung</div>
                                <div className="space-y-2">
                                    {timeSlots.map((time: number) => ( 
                                        <div className="flex justify-between items-center text-sm" key={time}> 
                                            <span className="font-numeric text-pe-muted dark:text-gray-400">{time} min.</span> 
                                            <span className="text-customBeige font-semibold font-numeric">{fmtEUR(minutenPreis * time)}</span> 
                                        </div> 
                                    ))} 
                                </div>
                            </div>
                            )}
                        </div>

                        {/* Symmetrischer Footer Basis (Links) — mit Details einklappbar (God-Mode) */}
                        {isDetailsVisible && (
                        <div className="mt-auto pt-4 flex flex-col justify-end">
                            <hr className="border-[#222] my-2" /> 
                            <div className="flex justify-between items-center bg-pe-tile-header px-2.5 py-2 rounded-lg border border-customBeige/40 shadow-inner gap-2"> 
                                <div className="flex items-center gap-1.5 min-w-0" data-tooltip-id="app-tooltip" data-tooltip-content="Gib hier eine beliebige Minutenanzahl ein, um den Preis zu berechnen."> 
                                    <span className="text-[10px] text-customBeige font-bold uppercase tracking-wider whitespace-nowrap">Freie Eingabe:</span>
                                    <EditableField value={customMinutes} onSave={setCustomMinutes} format="minutes" className="w-20 !py-0.5 !px-1.5 !text-xs" formatCurrency={formatCurrency} /> 
                                </div> 
                                <span className="text-pe-text font-bold text-base font-numeric shrink-0">{fmtEUR(minutenPreis * customMinutes)}</span> 
                            </div> 
                            <div className="mt-1.5 text-[10px] text-pe-muted dark:text-gray-400 flex justify-between items-center px-1">
                                <span>Wert p. Min. <span className="text-customBeige font-numeric ml-1">{fmtEUR(minutenPreis)}</span></span>
                                <span>{useEchterStundensatz ? 'IST-Rücklage' : 'Ziel-Rücklage'} <span className={`${useEchterStundensatz && diff < 0 ? 'text-red-400' : 'text-blue-400'} font-numeric ml-1`}>{formatPercent(useEchterStundensatz ? realProfitMargin : kalkRuecklage)}</span></span>
                            </div>
                        </div>
                        )}
                    </div> 

                    {/* --- RECHTE SPALTE (MATERIAL) --- */}
                    <div className="flex flex-col lg:pl-10"> 
                        <div className="flex-grow space-y-3">
                            {/* 💉 BOX 1: IMMER STATISCH EMPFEHLUNG (Kompakt + DYNAMISCHES GEWICHT AUS ADMIN-PARAMETER) */}
                            {baseMatParam && (
                                <div className="bg-pe-tile-header px-2.5 py-2 rounded-lg border border-yellow-600/40 shadow-inner relative overflow-hidden mb-2">
                                    <div className="absolute top-0 left-0 w-0.5 h-full bg-yellow-600"></div>
                                    <div className="font-bold text-[10px] text-yellow-500 mb-1 uppercase tracking-wider pl-2">
                                        Empfehlung inkl. {baseMatGrams}g Material
                                    </div> 
                                    <div className="flex justify-between items-center pl-2 gap-2"> 
                                        <div>
                                            <span className="font-numeric text-pe-text text-xs block leading-none">60 min. (Soll)</span> 
                                            <span className="text-[10px] font-semibold block mt-0.5 text-blue-400 leading-none">
                                                Ziel-Rücklage: {formatPercent(targetMatRuecklage)}
                                            </span>
                                        </div>
                                        <span className="text-pe-text font-bold text-base font-numeric">{fmtEUR(targetMatPreis)}</span> 
                                    </div> 
                                </div>
                            )}

                            {/* Toggle Material & IST-Box */}
                            {showMatToggle && (
                                <div className="py-2 space-y-4 animate-fade-in">
                                    <div>
                                        <label className="flex items-start gap-3 cursor-pointer mb-2">
                                            <input 
                                                type="checkbox" 
                                                checked={useEchterStundensatzMat} 
                                                onChange={handleToggleEchterStundensatzMat} 
                                                className="mt-0.5 border-yellow-600/50 checked:bg-yellow-600 checked:border-yellow-600 focus:ring-yellow-600" 
                                                style={{boxShadow: useEchterStundensatzMat ? '0 0 10px #ca8a04' : ''}}
                                            />
                                            <span className="text-sm text-yellow-600/90 font-bold leading-tight mt-0.5">Mein echter Stundensatz (inkl. Mat) weicht ab</span>
                                        </label>

                                        {/* 💉 BOX 2: IST-WERT MAT (Kompakt mit Tooltip) */}
                                        {useEchterStundensatzMat && (
                                            <div 
                                                className="bg-pe-sunken p-3 rounded-xl border border-pe-border dark:border-[#222] shadow-inner animate-in fade-in slide-in-from-top-2 cursor-help" 
                                                data-tooltip-id="app-tooltip" 
                                                data-tooltip-content={warningTooltipMat}
                                            >
                                                <div className="font-black text-xs text-pe-muted dark:text-gray-400 mb-1.5 uppercase tracking-widest">
                                                    Dein echter Stundenfaktor (IST)
                                                </div>
                                                <div className="flex justify-between items-center mb-1.5">
                                                    <div>
                                                        <span className="font-numeric text-pe-muted dark:text-gray-300 text-base block leading-none">60 min. (Soll)</span> 
                                                        <span className={`text-[11px] font-bold block mt-1 leading-none ${diffMat < 0 ? 'text-red-400' : 'text-blue-400'}`}>
                                                            IST-Rücklage: {formatPercent(realProfitMarginMat)}
                                                        </span>
                                                    </div>
                                                    <EditableField 
                                                        value={echterStundensatzMat} 
                                                        onSave={setEchterStundensatzMat} 
                                                        format="currency" 
                                                        className="min-w-[120px] !bg-pe-input dark:!bg-black !text-yellow-700 dark:!text-yellow-500 !font-black !text-lg !py-1 !px-2 border border-yellow-600/80 shadow-[0_0_10px_rgba(202,138,4,0.3)]" 
                                                        formatCurrency={formatCurrency} 
                                                    />
                                                </div>
                                                <div className="flex justify-between items-center mt-2">
                                                    <span className="text-[11px] text-yellow-600/90">✏️ IST-Wert eintragen</span>
                                                    <span className={`text-[11px] font-bold ${diffMat > 0 ? 'text-green-400' : diffMat < 0 ? 'text-orange-400' : 'text-stone-500 dark:text-gray-500'}`}>
                                                        {diffMat !== 0 ? `${diffMat > 0 ? '▲' : '▼'} ${fmtEUR(Math.abs(diffMat))}` : 'Entspricht Empfehlung'}
                                                    </span>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            )}

                            {/* Preis-Parameter Liste — einklappbar nur God-Mode */}
                            {isDetailsVisible && (
                            <div>
                                <div className="flex justify-between items-baseline mb-2 mt-4"> 
                                    <div className="font-bold text-sm text-pe-muted dark:text-gray-400 uppercase tracking-wider whitespace-nowrap">Parameter</div> 
                                    <div className="font-bold text-sm text-pe-muted dark:text-gray-400 uppercase tracking-wider text-right whitespace-nowrap ml-4">Rücklagen</div> 
                                </div> 
                                
                                <div className="space-y-2">
                                    {(adminParamData || []).filter((p:any) => p.id !== baseMatParam?.id).map((param: any) => ( 
                                        <div className="dynamic-param grid grid-cols-[1fr_auto] gap-4 items-center border-b border-pe-border dark:border-[#222] pb-1 last:border-0" key={param.id}> 
                                            <span className="text-pe-muted dark:text-gray-300 break-words text-left text-sm" title={param.desc}>{param.desc || 'Parameter'}</span> 
                                            <div className="flex items-center gap-3 whitespace-nowrap justify-end text-sm"> 
                                                <span className="text-customBeige font-semibold font-numeric">{fmtEUR(param.preis)}</span> 
                                                <span className="text-gray-600">/</span>
                                                <span className="text-blue-400 font-numeric">{formatPercent(param.ruecklage)}</span> 
                                            </div> 
                                        </div> 
                                    ))} 
                                </div>
                            </div>
                            )}
                        </div>

                        {/* Symmetrischer Footer Material (Rechts) — mit Details einklappbar (God-Mode) */}
                        {isDetailsVisible && (
                        <div className="mt-auto pt-4 flex flex-col justify-end">
                            <hr className="border-[#222] my-2" /> 
                            <div className="flex justify-between items-center bg-pe-tile-header px-2.5 py-2 rounded-lg border border-yellow-600/40 shadow-inner gap-2">
                                <div className="flex items-center gap-1.5 min-w-0" data-tooltip-id="app-tooltip" data-tooltip-content={`Schnellrechner basiert auf Deinem aktuellen Material-Stundensatz (${fmtEUR(activeStundenfaktorMat)}/h)`}>
                                    <span className="text-[10px] text-yellow-500 font-bold uppercase tracking-wider whitespace-nowrap">Freie Eingabe:</span>
                                    <EditableField value={customMatMinutes} onSave={setCustomMatMinutes} format="minutes" className="w-20 !py-0.5 !px-1.5 !text-xs !border-yellow-600/50" formatCurrency={formatCurrency} />
                                </div>
                                <span className="text-pe-text font-bold text-base font-numeric shrink-0">{fmtEUR(matMinutenPreis * customMatMinutes)}</span>
                            </div>
                            <div className="mt-1.5 text-[10px] text-pe-muted dark:text-gray-400 flex justify-between items-center px-1">
                                <span>Wert p. Min. <span className="text-yellow-500 font-numeric ml-1">{fmtEUR(matMinutenPreis)}</span></span>
                                <span>{useEchterStundensatzMat ? 'IST-Rücklage' : 'Ziel-Rücklage'} <span className={`${useEchterStundensatzMat && diffMat < 0 ? 'text-red-400' : 'text-blue-400'} font-numeric ml-1`}>{formatPercent(useEchterStundensatzMat ? realProfitMarginMat : targetMatRuecklage)}</span></span>
                            </div>
                        </div>
                        )}

                    </div> 
                    
                    {/* Datums-Stempel — mit Details einklappbar (God-Mode) */}
                    {isDetailsVisible && (
                    <div className="col-span-1 md:col-span-2 mt-6 text-center text-xs text-stone-500 dark:text-gray-500 border-t border-pe-border dark:border-[#222] pt-4">
                        Aktualisiert am <span className="font-numeric">{updateDatum}</span>
                    </div>
                    )}

                </div>
            </div> 
        </section> 
    );
};

const MitarbeiterListe = ({ data, formatCurrency }: any) => {
    const avg = useMemo(() => {
        if (!data || data.length === 0) return 0;
        const sum = data.reduce((acc: number, curr: any) => acc + curr.stundensatz, 0);
        return Math.ceil(sum / data.length); 
    }, [data]);

    const formatInt = (num: number) => {
        return symbolToText(formatCurrency(num, 0));
    };

    return (
        <div 
            className="flex flex-row items-stretch bg-pe-tile-header rounded-lg border border-pe-border dark:border-[#222] mb-2 text-[11px] sm:text-sm text-pe-muted dark:text-gray-400 transition-colors hover:border-customBeige/50 shadow-inner cursor-help tooltip-shift-left overflow-hidden"
            data-tooltip-id="app-tooltip"
            data-tooltip-content="Erforderliche Umsätze der prod. Mitarbeiter bei einer Auslastung von 75%."
        >
            <div className="flex items-center gap-2 min-w-0 flex-1 pl-2 py-1.5">
                <span className="uppercase tracking-wider font-bold text-stone-500 dark:text-gray-500 shrink-0">Team:</span>
                <div className="min-w-0 flex-1 overflow-x-auto scrollbar-none [-ms-overflow-style:none] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
                    <div className="flex gap-3 sm:gap-4 flex-nowrap pr-2">
                        {(data || []).map((ma: any, idx: number) => (
                            <div key={idx} className="flex gap-1 items-center whitespace-nowrap shrink-0"> 
                                <span className="text-pe-muted dark:text-gray-300">{ma.name}</span> 
                                {ma.hasGeraete && (
                                    <span className="text-yellow-500 text-xs cursor-help" data-tooltip-id="app-tooltip" data-tooltip-content="Mitarbeiter nutzt Geräte – Geräte-Kosten werden separat im Kalkulator berechnet.">⚡</span>
                                )}
                                <span className="text-pe-text font-numeric">{formatInt(ma.stundensatz)}</span> 
                            </div>
                        ))}
                    </div>
                </div>
            </div>
            <div className="flex items-center gap-1.5 shrink-0 border-l border-pe-border dark:border-[#222] pl-2 pr-2 py-1.5 bg-pe-tile-header z-[1]">
                <span className="font-semibold">Ø</span>
                <span className="text-customBeige font-numeric font-bold whitespace-nowrap">{formatInt(avg)}</span>
            </div>
        </div>
    );
};

const KalkulatorInputs = ({ inputs, setInputs, formatCurrency, onChangeBedienzeit }: any) => { 
    const { bisherigerPreis, bedienzeit, neuerPreis } = inputs;
    const anpassung = useMemo(() => ( bisherigerPreis > 0 ? ((neuerPreis / bisherigerPreis) - 1) * 100 : 0 ), [bisherigerPreis, neuerPreis]);
    
    const info = useMemo(() => { 
        if (anpassung >= 25) return { class: 'anpassung-critical', text: 'Anpassung viel zu hoch!', icon: '🚨' }; 
        if (anpassung > 15) return { class: 'anpassung-moderate', text: 'Anpassung ist in Ordnung.', icon: '↗️' }; 
        return { class: 'anpassung-ok', text: 'Anpassung ist gut.', icon: '↗️' }; 
    }, [anpassung]);

    const nudgeAnpassung = (dir: -1 | 1) => {
        if (!(bisherigerPreis > 0)) return;
        const stepPct = 1;
        const curPct = anpassung;
        const rem = ((curPct % stepPct) + stepPct) % stepPct;
        const isAligned = rem < 0.05 || stepPct - rem < 0.05;
        let targetPct: number;
        if (!isAligned) {
            targetPct = dir > 0 ? Math.ceil(curPct) : Math.floor(curPct);
        } else {
            targetPct = Math.round(curPct) + dir * stepPct;
        }
        const nextNeuerPreis = Math.max(0, Number((bisherigerPreis * (1 + targetPct / 100)).toFixed(2)));
        setInputs((p: any) => ({ ...p, neuerPreis: nextNeuerPreis }));
    };

    return ( 
        <div className="grid grid-cols-4 gap-1.5 sm:gap-4 items-start mb-2 sm:mb-4 pb-2 sm:pb-4 border-b border-pe-border dark:border-[#222]"> 
            <h3 className="col-span-4 text-sm sm:text-2xl font-bold border-b border-pe-border dark:border-[#222] pb-1 sm:pb-3 mb-1 sm:mb-2 text-customBeige">Kalkulator</h3> 
            
            <div className="flex flex-col text-center cursor-help min-w-0" data-tooltip-id="app-tooltip" data-tooltip-content="Der aktuelle Verkaufspreis Deiner Dienstleistung. ± in 5-€-Schritten."> 
                <label className="flex items-end justify-center h-5 sm:h-6 text-[9px] sm:text-xs font-bold text-stone-500 dark:text-gray-500 uppercase tracking-wide sm:tracking-widest mb-0.5 sm:mb-1 leading-tight">
                    <span className="sm:hidden">Bisher</span>
                    <span className="hidden sm:inline">bisher. Preis</span>
                </label> 
                <SteppedEditableField
                    value={bisherigerPreis}
                    onSave={(val) => setInputs((p: any) => ({ ...p, bisherigerPreis: val }))}
                    step={5}
                    format="currency"
                    className="w-full !py-1 sm:!py-2 !text-xs sm:!text-base !px-0.5 sm:!px-1"
                    formatCurrency={formatCurrency}
                    ariaLabel="Bisheriger Preis"
                    compact
                />
                <div className="hidden sm:block h-4" aria-hidden="true" />
            </div> 
            <div className="flex flex-col text-center cursor-help min-w-0" data-tooltip-id="app-tooltip" data-tooltip-content="Die reine Arbeitszeit in Minuten. ± in 5-Minuten-Schritten (passt den Preis automatisch an)."> 
                <label className="flex items-end justify-center h-5 sm:h-6 text-[9px] sm:text-xs font-bold text-stone-500 dark:text-gray-500 uppercase tracking-wide sm:tracking-widest mb-0.5 sm:mb-1 leading-tight">
                    <span className="sm:hidden">Zeit</span>
                    <span className="hidden sm:inline">Bedienzeit</span>
                </label> 
                <SteppedEditableField
                    value={bedienzeit}
                    onSave={(val) => {
                        if (onChangeBedienzeit) {
                            onChangeBedienzeit(val);
                        } else {
                            setInputs((p: any) => ({ ...p, bedienzeit: val }));
                        }
                    }}
                    step={5}
                    format="minutes"
                    className="w-full !py-1 sm:!py-2 !text-xs sm:!text-base !px-0.5 sm:!px-1"
                    ariaLabel="Bedienzeit"
                    compact
                />
                <div className="hidden sm:block h-4" aria-hidden="true" />
            </div> 
            <div className="flex flex-col text-center cursor-help min-w-0" data-tooltip-id="app-tooltip" data-tooltip-content="Der geplante neue Preis. ± rundet sauber auf 5-€-Schritte."> 
                <label className="flex items-end justify-center h-5 sm:h-6 text-[9px] sm:text-xs font-bold text-stone-500 dark:text-gray-500 uppercase tracking-wide sm:tracking-widest mb-0.5 sm:mb-1 leading-tight">
                    <span className="sm:hidden">Neu</span>
                    <span className="hidden sm:inline">neuer Preis</span>
                </label> 
                <SteppedEditableField
                    value={neuerPreis}
                    onSave={(val) => setInputs((p: any) => ({ ...p, neuerPreis: val }))}
                    step={5}
                    format="currency"
                    className="w-full !py-1 sm:!py-2 !text-xs sm:!text-base !px-0.5 sm:!px-1"
                    formatCurrency={formatCurrency}
                    ariaLabel="Neuer Preis"
                    compact
                />
                <div className="hidden sm:block h-4" aria-hidden="true" />
            </div> 
            
            <div className="flex flex-col text-center cursor-help min-w-0" data-tooltip-id="app-tooltip" data-tooltip-content="Zeigt die prozentuale Veränderung zum bisherigen Preis. Mit − / + kannst du die gewünschte Preisanpassung in %-Schritten direkt einstellen."> 
                <label className="flex items-end justify-center h-5 sm:h-6 text-[9px] sm:text-xs font-bold text-stone-500 dark:text-gray-500 uppercase tracking-wide sm:tracking-widest mb-0.5 sm:mb-1 leading-tight">Anpassung</label> 
                <div className="step-field-wrap step-field-compact">
                    <button
                        type="button"
                        className="step-btn"
                        aria-label="Anpassung verringern"
                        onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            nudgeAnpassung(-1);
                        }}
                    >
                        −
                    </button>
                    <div className={`flex-1 min-w-0 flex items-center justify-center font-semibold text-center text-sm sm:text-xl font-numeric whitespace-nowrap leading-none ${info.class}`}> 
                        <span>{formatPercent(anpassung)}</span>
                        <span className="ml-1 text-[0.85em] leading-none" aria-hidden="true">{info.icon}</span>
                    </div> 
                    <button
                        type="button"
                        className="step-btn"
                        aria-label="Anpassung erhöhen"
                        onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            nudgeAnpassung(1);
                        }}
                    >
                        +
                    </button>
                </div>
                <div className="hidden sm:block text-[10px] sm:text-xs text-pe-muted dark:text-gray-400 h-4 leading-4 truncate">{info.text}</div> 
            </div> 
        </div> 
    );
};

const GewinnGauge = ({ gewinn, gewinnPercent, formatCurrency, targetPercent = 12.5 }: any) => { 
    const gaugeSettings = useMemo(() => {
        if (gewinnPercent >= targetPercent * 1.6) { return { color: '#8b5cf6', textColor: 'text-exzellent', text: 'Hervorragendes Ergebnis', iconType: 'star', highlightColor: '#a78bfa' }; } 
        else if (gewinnPercent >= targetPercent * 1.2) { return { color: '#3b82f6', textColor: 'text-gut', text: 'Gesunde Rücklagen', iconType: 'double_check', highlightColor: '#60a5fa' }; } 
        else if (gewinnPercent >= targetPercent) { return { color: '#16a34a', textColor: 'text-gewinn', text: 'Solider Gewinn', iconType: 'check', highlightColor: '#4ade80' }; } 
        else if (gewinnPercent >= 0) { return { color: '#ca8a04', textColor: 'text-kostendeckend', text: 'Kostendeckend', iconType: 'dash', highlightColor: '#facc15' }; } 
        else { return { color: '#dc2626', textColor: 'text-verlust', text: 'Verlust', iconType: 'cross', highlightColor: '#f87171' }; }
    }, [gewinnPercent, targetPercent]);

    const radius = 40; 
    const circumference = 2 * Math.PI * radius; 
    const maxScale = Math.max(20, targetPercent * 1.6);
    const visualPercent = Math.min(Math.max(0, gewinnPercent), maxScale) / maxScale;
    const offset = circumference * (1 - visualPercent); 

    const renderIcon = () => {
        const shadow = "drop-shadow(1px 2px 2px rgba(0,0,0,0.5))";
        const stroke = "white";
        const strokeWidth = "10"; 
        switch (gaugeSettings.iconType) {
            case 'cross': return <path d="M30 30 L70 70 M70 30 L30 70" stroke={stroke} strokeWidth={strokeWidth} strokeLinecap="round" filter={shadow} />;
            case 'dash': return <path d="M25 50 H75" stroke={stroke} strokeWidth={strokeWidth} strokeLinecap="round" filter={shadow} />;
            case 'check': return <path d="M30 50 L45 65 L75 35" fill="none" stroke={stroke} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" filter={shadow} />;
            case 'double_check': return ( <g> <path d="M20 50 L35 65 L65 35" fill="none" stroke={stroke} strokeWidth="8" strokeLinecap="round" strokeLinejoin="round" filter={shadow} opacity="0.6" transform="translate(-5, 0)"/> <path d="M35 50 L50 65 L80 35" fill="none" stroke={stroke} strokeWidth="8" strokeLinecap="round" strokeLinejoin="round" filter={shadow} /> </g> );
            case 'star': return <path d="M50 15 L61 39 H88 L66 57 L75 85 L50 69 L25 85 L34 57 L12 39 H39 Z" fill={stroke} filter={shadow} transform="scale(0.8) translate(12, 12)" />;
            default: return null;
        }
    };

    const isLight = typeof document !== 'undefined' && !document.documentElement.classList.contains('dark');
    const borderTone = isLight
        ? (gaugeSettings.textColor === 'text-gut' ? '#1E3A8A'
            : gaugeSettings.textColor === 'text-exzellent' ? '#5B21B6'
            : gaugeSettings.textColor === 'text-gewinn' ? '#15803D'
            : gaugeSettings.textColor === 'text-kostendeckend' ? '#A16207'
            : gaugeSettings.textColor === 'text-verlust' ? '#B91C1C'
            : gaugeSettings.highlightColor)
        : gaugeSettings.highlightColor;

    return ( 
        <div 
            className={`mt-2 sm:mt-4 p-2 sm:p-3 gauge-container-3d flex flex-row items-center justify-around gap-2 sm:gap-4${isLight ? ' pe-gauge-light' : ''}`} 
            style={{
                minHeight: undefined, 
                borderWidth: '2px', 
                borderColor: borderTone, 
                boxShadow: isLight
                    ? `0 0 0 1px ${borderTone}22, 0 2px 10px rgba(28,25,23,0.12)`
                    : `0 0 20px ${gaugeSettings.highlightColor}40, inset 0 0 30px rgba(0,0,0,0.8)`
            }}
        > 
            <div className="relative w-14 h-14 sm:w-28 sm:h-28 flex-shrink-0"> 
                <svg className="w-full h-full drop-shadow-2xl" viewBox="0 0 100 100">
                    <defs>
                        <filter id="glow" x="-50%" y="-50%" width="200%" height="200%"> <feGaussianBlur stdDeviation="2.5" result="coloredBlur"/> <feMerge> <feMergeNode in="coloredBlur"/> <feMergeNode in="SourceGraphic"/> </feMerge> </filter>
                        <filter id="inner-shadow"> <feOffset dx="0" dy="1"/> <feGaussianBlur stdDeviation="1" result="offset-blur"/> <feComposite operator="out" in="SourceGraphic" in2="offset-blur" result="inverse"/> <feFlood floodColor="black" floodOpacity="0.75" result="color"/> <feComposite operator="in" in="color" in2="inverse" result="shadow"/> <feComposite operator="over" in="shadow" in2="SourceGraphic"/> </filter>
                        <radialGradient id="buttonGradient" cx="50%" cy="50%" r="50%" fx="30%" fy="30%"> <stop offset="0%" stopColor={gaugeSettings.highlightColor} stopOpacity="1"/> <stop offset="100%" stopColor="#000000" stopOpacity="0.6"/> </radialGradient>
                        <filter id="button3D" x="-50%" y="-50%" width="200%" height="200%"> <feDropShadow dx="0" dy="5" stdDeviation="4" floodColor="rgba(0,0,0,0.6)" /> <feGaussianBlur in="SourceAlpha" stdDeviation="2" result="blur" /> <feOffset in="blur" dx="0" dy="2" result="offsetBlur" /> <feSpecularLighting in="blur" surfaceScale="5" specularConstant="0.8" specularExponent="40" result="specOut" lightingColor="white"> <fePointLight x="-5000" y="-10000" z="20000" /> </feSpecularLighting> <feComposite in="specOut" in2="SourceAlpha" operator="in" result="specOut" /> <feComposite in="SourceGraphic" in2="specOut" operator="arithmetic" k1="0" k2="1" k3="0.4" k4="0" /> </filter>
                        <linearGradient id="gaugeGradient" x1="0%" y1="0%" x2="100%" y2="100%"> <stop offset="0%" stopColor={gaugeSettings.color} stopOpacity="1" /> <stop offset="100%" stopColor="#ffffff" stopOpacity="0.5" /> </linearGradient>
                    </defs>
                    <circle cx="50" cy="50" r={radius} fill="none" stroke={isLight ? '#C9C3BC' : '#0f172a'} strokeWidth="8" style={{filter: 'drop-shadow(0 1px 1px rgba(255,255,255,0.1))'}} />
                    <circle id="gewinn-gauge-progress" cx="50" cy="50" r={radius} fill="none" stroke={`url(#gaugeGradient)`} strokeWidth="8" strokeLinecap="round" style={{ strokeDasharray: circumference, strokeDashoffset: offset, transform: 'rotate(-90deg)', transformOrigin: '50% 50%', filter: isLight ? undefined : 'url(#glow)' }} />
                    <g transform="translate(28, 28) scale(0.44)"> <rect x="10" y="10" width="80" height="80" rx="25" fill={gaugeSettings.color} style={{filter: 'url(#button3D)'}} /> {renderIcon()} <path d="M20 20 Q 50 5, 80 20 Q 70 40, 50 35 Q 30 40, 20 20" fill="white" opacity="0.15" /> </g>
                </svg> 
            </div> 
            <div className="text-center space-y-0 sm:space-y-1"> <div className="text-[8px] sm:text-xs text-pe-muted dark:text-gray-400 uppercase tracking-wider">Gewinn</div> <div className={`text-base sm:text-3xl font-bold font-numeric pe-gauge-value ${gaugeSettings.textColor}`}>{symbolToText(formatCurrency(gewinn))}</div> </div> 
            <div className="text-center space-y-0 sm:space-y-1"> <div className="text-[8px] sm:text-xs text-pe-muted dark:text-gray-400 uppercase tracking-wider">Rücklage</div> <div className={`text-base sm:text-3xl font-semibold font-numeric pe-gauge-value ${gaugeSettings.textColor}`}>{formatPercent(gewinnPercent)}</div> </div> 
            <div className="text-center space-y-0 sm:space-y-1 min-w-0"> <div className="text-[8px] sm:text-xs text-pe-muted dark:text-gray-400 uppercase tracking-wider">Status</div> <div className={`text-[11px] sm:text-lg font-bold leading-tight pe-gauge-status ${gaugeSettings.textColor}`}>{gaugeSettings.text}</div> </div> 
        </div> 
    );
};

const GeraeteDisplay = ({ geraeteData, formatCurrency }: any) => {
    if (!geraeteData || geraeteData.length === 0) return null;
    return ( 
        <section className="carbon-panel carbon-weave-bg w-full lg:max-w-[434px]"> 
            <div className="carbon-content p-6">
                <div className="border-b border-pe-border dark:border-[#222] pb-3 mb-4"> <h2 className="text-xl font-semibold text-customBeige">Stundenfaktor mit Geräten</h2> </div> 
                <div className="space-y-3 text-lg"> 
                    {(geraeteData || []).map((device: any) => ( 
                        <div key={device.id} className="flex justify-between items-center"> 
                            <span className="text-pe-muted dark:text-gray-300">{device.desc}</span> 
                            <span className="text-customBeige font-semibold font-numeric">{symbolToText(formatCurrency(device.preis))}</span> 
                        </div> 
                    ))} 
                </div> 
            </div>
        </section> 
    );
};

// 💉 CHIRURGIE-FIX: effectiveSozialabgabenPercent als Parameter hinzugefügt, damit das UI korrekt reagiert
const HauptKalkulator = ({ materialData, surchargeData, onScrollToMaterial, inputs, setInputs, selectedSurchargeId, setSelectedSurchargeId, activeMaterialIDs, toggleMaterial, activeDeviceIDs, toggleDevice, calculations, mitarbeiterData, storeCalc, onOpenPreislisteModal, onOpenPaketpreisModal, paketDraftCount, onOpenMasterTool, geraeteDisplayData, effectiveSozialabgabenPercent }: any) => { 
    const hasDevicesInStructure = (storeCalc.geraeteListe || []).length > 0;
    const devicesCurrentlyChecked = (activeDeviceIDs || new Set()).size > 0;
    const formatCurrency = storeCalc.formatCurrency;
    const [matOpenMobile, setMatOpenMobile] = useState(false);
    const activeMatCount = (activeMaterialIDs || new Set()).size;
    const activeDevCount = (activeDeviceIDs || new Set()).size;

    const fmtEUR = (val: number) => symbolToText(formatCurrency(val));

    return ( 
        <div className="flex flex-col xl:flex-row items-start gap-3 xl:gap-8"> 
            {/* Mobil: Material/Geräte als schmale Klappe — nicht als volle Höhe davor */}
            <div className="xl:hidden w-full order-1"> 
                <div className="carbon-panel carbon-weave-bg w-full"> 
                    <div className="carbon-content px-3 py-2">
                        <button
                            type="button"
                            onClick={() => setMatOpenMobile(v => !v)}
                            className="w-full flex items-center justify-between gap-2 text-left"
                        >
                            <div className="min-w-0">
                                <span className="text-sm font-bold text-customBeige">Material / Geräte</span>
                                <span className="ml-2 text-[10px] font-mono text-stone-500 dark:text-gray-500">
                                    {activeMatCount} Mat{hasDevicesInStructure ? ` · ${activeDevCount} Ger` : ''}
                                </span>
                            </div>
                            <div className="flex items-center gap-2 shrink-0">
                                <span
                                    role="button"
                                    tabIndex={0}
                                    onClick={(e) => { e.stopPropagation(); onScrollToMaterial(); }}
                                    onKeyDown={(e) => { if (e.key === 'Enter') { e.stopPropagation(); onScrollToMaterial(); } }}
                                    className="action-btn !text-[10px] !px-2 !py-1"
                                >
                                    Rechner ↓
                                </span>
                                <span className={`text-customBeige text-xs transition-transform ${matOpenMobile ? 'rotate-180' : ''}`}>▼</span>
                            </div>
                        </button>
                        {matOpenMobile && (
                            <div className="mt-2 pt-2 border-t border-pe-border dark:border-[#222]">
                                <div className="flex justify-end mb-1">
                                    <span className="text-[9px] font-black uppercase tracking-widest text-stone-500 dark:text-slate-500">Preis pro 100&nbsp;ml/g</span>
                                </div>
                                <div className="space-y-1.5 max-h-40 overflow-y-auto"> 
                                    {(materialData || []).map((m: any) => ( 
                                        <div key={m.id} className="flex items-center justify-between text-xs gap-2"> 
                                            <div className="flex items-center gap-2 min-w-0"> 
                                                <input type="checkbox" id={`activator-mobile-${m.id}`} checked={(activeMaterialIDs || new Set()).has(m.id)} onChange={() => toggleMaterial(m.id)} /> 
                                                <label htmlFor={`activator-mobile-${m.id}`} className="text-pe-muted dark:text-gray-300 truncate">{m.name}</label> 
                                            </div> 
                                            <span className="text-customBeige font-semibold font-numeric whitespace-nowrap shrink-0" title="Umrechnung: Gebinde-EK ÷ Gebindegröße × 100">
                                                {fmtEUR(m.gebinde > 0 ? (m.ekPreis/m.gebinde)*100 : 0)}
                                                <span className="text-[9px] font-bold text-stone-500 dark:text-slate-500 ml-1">/100</span>
                                            </span> 
                                        </div> 
                                    ))} 
                                </div>
                                {hasDevicesInStructure && (
                                    <div className="mt-3 pt-2 border-t border-pe-border dark:border-[#222]">
                                        <h4 className="text-[10px] font-bold text-customBeige uppercase tracking-wider mb-1.5">Geräte</h4>
                                        <div className="space-y-1.5">
                                            {(storeCalc.geraeteListe || []).filter((g: any): g is Geraet => g !== null).map((d: Geraet) => (
                                                <div key={d.id} className="flex items-center justify-between text-xs gap-2">
                                                    <div className="flex items-center gap-2 min-w-0">
                                                        <input type="checkbox" id={`device-activator-mobile-${d.id}`} checked={(activeDeviceIDs || new Set()).has(d.id)} onChange={() => toggleDevice(d.id)} />
                                                        <label htmlFor={`device-activator-mobile-${d.id}`} className="text-pe-muted dark:text-gray-300 truncate">{d.name}</label>
                                                    </div>
                                                    <span className="text-customBeige font-numeric shrink-0">{d.kostenProzent.toLocaleString('de-DE', { minimumFractionDigits: 1, maximumFractionDigits: 1 })}%</span>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                </div> 
            </div> 
            <div className="flex-grow flex flex-col w-full order-2 xl:order-1 min-w-0"> 
                <section className="carbon-panel carbon-weave-bg w-full">
                    <div className="carbon-content p-3 sm:p-5">
                    <MitarbeiterListe data={mitarbeiterData} formatCurrency={formatCurrency} />
                    
                    <KalkulatorInputs 
                        inputs={inputs} 
                        setInputs={setInputs} 
                        formatCurrency={formatCurrency}
                        onChangeBedienzeit={(nextMinsRaw: number) => {
                            const nextMins = Math.max(5, Number(nextMinsRaw) || 60);
                            const prevMins = Math.max(5, Number(inputs.bedienzeit) || 60);
                            const mwst = (storeCalc.mwstSatz || 0) / 100;
                            const gk = storeCalc.gemeinkostenfaktor || 0;
                            const ul = (storeCalc.unprodUnternehmerlohnPercent || 0) / 100;
                            const vl = (storeCalc.settings?.global?.Verlust_1 || 0) / 100;
                            const ruecklage = (Number(storeCalc.clientData?.liquiditaet ?? storeCalc.settings?.global?.Liquiditaet) || 10) / 100;

                            let mSum = 0;
                            let mCnt = 0;
                            (activeMaterialIDs || new Set()).forEach((id: string) => {
                                const m = (materialData || []).find((x: any) => x.id === id);
                                if (m && m.gebinde > 0) {
                                    mSum += (m.ekPreis / m.gebinde) * 100;
                                    mCnt++;
                                }
                            });
                            const avg100 = mCnt > 0 ? mSum / mCnt : 0;
                            const wawiVk = Number(storeCalc.settings?.global?.Warenwirtschaftsaufschlag_VK);
                            const matFaktor = Number.isFinite(wawiVk) && wawiVk > 0 ? wawiVk : 1.3;
                            const matCost = ((avg100 / 100) * (Number(inputs.materialGramm) || 0) + (Number(inputs.materialPreis) || 0)) * matFaktor;

                            let dPerc = 0;
                            (activeDeviceIDs || new Set()).forEach((id: string) => {
                                const d = (storeCalc.geraeteListe || []).find((x: any) => x?.id === id);
                                if (d) dPerc += d.kostenProzent;
                            });
                            const sPrice = ((surchargeData || []).find((x: any) => x.id === selectedSurchargeId)?.price || 0) / (1 + mwst);

                            const lohnBasis = Number(((storeCalc.teamStundenlohn || 0) * (nextMins / 60)).toFixed(2));
                            const urlaubVal = Number((lohnBasis * ((storeCalc.lohnfortzahlungPercent || 0) / 100)).toFixed(2));
                            const sozialVal = Number(((lohnBasis + urlaubVal) * ((effectiveSozialabgabenPercent || 0) / 100)).toFixed(2));
                            const totalLohn = Number((lohnBasis + urlaubVal + sozialVal).toFixed(2));

                            const factorZiel = 1 - dPerc / 100 - gk - ul - vl - ruecklage;
                            const autoNeuerPreis =
                                factorZiel > 0.05
                                    ? Number((((Math.max(0, totalLohn + matCost - sPrice)) / factorZiel) * (1 + mwst)).toFixed(2))
                                    : inputs.neuerPreis;

                            const scaledBisher =
                                inputs.bisherigerPreis > 0
                                    ? Number(((inputs.bisherigerPreis / prevMins) * nextMins).toFixed(2))
                                    : inputs.bisherigerPreis;

                            setInputs((p: any) => ({
                                ...p,
                                bedienzeit: nextMins,
                                bisherigerPreis: scaledBisher,
                                neuerPreis: autoNeuerPreis,
                            }));
                        }}
                    /> 

                    <div className="flex flex-col sm:flex-row items-stretch gap-2 sm:gap-4"> 
                        <div className="flex-grow w-full flex flex-col min-w-0"> 
                            <div className="grid grid-cols-[minmax(0,1fr)_auto_auto] sm:grid-cols-[2fr_0.8fr_1fr_1fr] gap-x-2 sm:gap-x-4 gap-y-1.5 sm:gap-y-3 items-start text-sm sm:text-base leading-snug">
                                <div className="text-pe-muted dark:text-slate-300 py-0">abzügl. MwSt.</div> 
                                <div className="text-right sm:text-center text-[11px] sm:text-base text-stone-500 dark:text-gray-500 font-numeric py-0 tabular-nums">{storeCalc.mwstSatz}%</div> 
                                <div className="text-right text-customBeige font-semibold font-numeric py-0">{fmtEUR(calculations.mwstValue)}</div> 
                                <div className="hidden sm:block text-right font-bold text-customBeige font-numeric py-0">{fmtEUR(calculations.nettoNachMwst)}</div>
                                
                                {hasDevicesInStructure && devicesCurrentlyChecked && ( 
                                    <> 
                                        <div className="text-pe-muted dark:text-slate-300 py-0">abzügl. Geräte</div> 
                                        <div className="text-right sm:text-center text-[11px] sm:text-base text-stone-500 dark:text-gray-500 font-numeric py-0 tabular-nums">{formatPercent(calculations.totalActivatedDevicePricePercent)}</div> 
                                        <div className="text-right text-customBeige font-semibold font-numeric py-0">{fmtEUR(calculations.totalActivatedDevicePrice)}</div> 
                                        <div className="hidden sm:block"></div> 
                                    </> 
                                )}
                                
                                <div className="text-pe-muted dark:text-slate-300 py-0">abzügl. Material</div> 
                                <div className="text-right sm:text-center text-[11px] sm:text-base text-stone-500 dark:text-gray-500 font-numeric py-0 tabular-nums">{formatPercent(calculations.totalMaterialCostPercent)}</div> 
                                <div className="text-right text-customBeige font-semibold font-numeric py-0">{fmtEUR(calculations.totalMaterialCost)}</div> 
                                <div className="hidden sm:block"></div>
                                
                                <div className="text-pe-muted dark:text-slate-300 py-0">abzügl. Gemeinkosten</div> 
                                <div className="text-right sm:text-center text-[11px] sm:text-base text-stone-500 dark:text-gray-500 font-numeric py-0 tabular-nums">{formatPercent((storeCalc.gemeinkostenfaktor || 0) * 100)}</div> 
                                <div className="text-right text-customBeige font-semibold font-numeric py-0">{fmtEUR(calculations.gemeinkostenValue)}</div> 
                                <div className="hidden sm:block"></div>
                                
                                <div className="text-pe-muted dark:text-slate-300 py-0"><span className="sm:hidden">abzügl. Unternehmerlohn</span><span className="hidden sm:inline">abzügl. unpr. Unternehmerlohn</span></div> 
                                <div className="text-right sm:text-center text-[11px] sm:text-base text-stone-500 dark:text-gray-500 font-numeric py-0 tabular-nums">{formatPercent(storeCalc.unprodUnternehmerlohnPercent || 0)}</div> 
                                <div className="text-right text-customBeige font-semibold font-numeric py-0">{fmtEUR(calculations.unternehmerlohnValue)}</div> 
                                <div className="hidden sm:block"></div>
                                
                                <div className="text-pe-muted dark:text-slate-300 py-0">abzügl. kalk. Verlust</div> 
                                <div className="text-right sm:text-center text-[11px] sm:text-base text-stone-500 dark:text-gray-500 font-numeric py-0 tabular-nums">{formatPercent(storeCalc.settings?.global?.Verlust_1 || 0)}</div> 
                                <div className="text-right text-customBeige font-semibold font-numeric py-0">{fmtEUR(calculations.verlustValue)}</div> 
                                <div className="hidden sm:block"></div>
                                
                                <div className="col-span-3 sm:col-span-4 border-b border-pe-border dark:border-[#222] my-0.5 sm:my-1" />
                                
                                <div className="font-bold text-sm sm:text-lg py-0 text-pe-text col-span-2 sm:col-span-1">übrig für Lohnkosten</div> 
                                <div className="text-right font-bold text-sm sm:text-lg text-customBeige font-numeric sm:col-start-4 py-0">{fmtEUR(calculations.uebrigFuerLohn)}</div>
                                
                                <div className="col-span-3 sm:col-span-4 mt-0.5 sm:mt-1 p-2 sm:p-3 bg-pe-sunken rounded-lg sm:rounded-xl border border-pe-border dark:border-[#222] shadow-[inset_0_2px_10px_rgba(0,0,0,0.5)]">
                                    <div className="grid grid-cols-[minmax(0,1fr)_auto] sm:grid-cols-[2fr_0.8fr_1fr_1fr] gap-x-3 sm:gap-x-4 items-center">
                                        <div className="text-pe-muted dark:text-slate-300 font-bold text-sm sm:text-base leading-tight">abzügl. Lohn &amp; Nebenkosten</div> 
                                        <div className="text-right text-customBeige font-bold text-base sm:text-xl font-numeric sm:col-start-4">{fmtEUR(calculations.lohnkostenValue)}</div>
                                        <div className="col-span-2 sm:col-start-3 sm:col-span-2 text-right text-[10px] sm:text-xs font-mono text-stone-500 dark:text-gray-500 mt-0.5 sm:mt-2 uppercase tracking-tight font-bold">
                                            Ø SV {effectiveSozialabgabenPercent.toLocaleString('de-DE', {minimumFractionDigits: 1, maximumFractionDigits: 1})}% | Url. {storeCalc.lohnfortzahlungPercent.toLocaleString('de-DE', {minimumFractionDigits: 1, maximumFractionDigits: 1})}%
                                        </div>
                                    </div>
                                </div>
                            </div> 
                        </div> 
                        {/* Desktop: Material/Team rechts neben Abzügen */}
                        <div className="hidden sm:flex w-[240px] flex-shrink-0 flex-col gap-2.5 justify-between"> 
                            <div className="bg-pe-tile-header rounded-xl p-3 border border-pe-border dark:border-[#222] shadow-[inset_0_2px_10px_rgba(0,0,0,0.5)] text-center cursor-help" data-tooltip-id="app-tooltip" data-tooltip-content="Trage hier den Netto-Materialpreis ein. Achtung: Es werden noch Material-Gemeinkosten aufgeschlagen. ± in 5-€-Schritten."> 
                                <h4 className="text-xs font-bold text-stone-500 dark:text-gray-500 uppercase tracking-widest mb-1.5">Mat. EUR</h4> 
                                <SteppedEditableField
                                    value={inputs.materialPreis}
                                    onSave={(v) => setInputs((p: any) => ({ ...p, materialPreis: v }))}
                                    step={5}
                                    format="currency"
                                    className="w-full !text-lg !font-bold !py-1 !px-1"
                                    formatCurrency={formatCurrency}
                                    ariaLabel="Materialpreis"
                                />
                            </div> 
                            <div className="bg-pe-card rounded-xl p-3 border border-customBeige/50 shadow-[inset_0_2px_10px_rgba(0,0,0,0.5)] text-center cursor-help" data-tooltip-id="app-tooltip" data-tooltip-content="Gib hier die verbrauchte menge in Gramm/Milliliter ein. ± in 5-g-Schritten."> 
                                <h4 className="text-xs font-bold text-customBeige uppercase tracking-widest mb-1.5">Mat. g</h4> 
                                <SteppedEditableField
                                    value={inputs.materialGramm}
                                    onSave={(v) => setInputs((p: any) => ({ ...p, materialGramm: v }))}
                                    step={5}
                                    format="gramm"
                                    className="w-full !text-lg !font-bold !py-1 !px-1"
                                    ariaLabel="Materialmenge"
                                />
                            </div> 
                            <div className="bg-pe-tile-header rounded-xl p-3 border border-pe-border dark:border-[#222] shadow-[inset_0_2px_10px_rgba(0,0,0,0.5)] text-center cursor-help mt-auto" data-tooltip-id="app-tooltip" data-tooltip-content="Durchschnittlicher Stundenlohn des produktiven Teams."> 
                                <h4 className="text-xs font-bold text-stone-500 dark:text-gray-500 uppercase tracking-widest mb-1.5">Team Lohn</h4> 
                                <div className="calculated-field w-full !text-lg !font-bold !py-0.5">{fmtEUR(storeCalc.teamStundenlohn)}</div> 
                            </div>
                        </div> 
                    </div>

                    {/* Mobil: Material + Team direkt über Zuschlag — Abzüge bleiben volle Breite */}
                    <div className="sm:hidden grid grid-cols-3 gap-2 mt-3">
                        <div className="bg-pe-tile-header rounded-lg p-2 border border-pe-border dark:border-[#222] shadow-[inset_0_2px_10px_rgba(0,0,0,0.5)] text-center" data-tooltip-id="app-tooltip" data-tooltip-content="Trage hier den Netto-Materialpreis ein. Achtung: Es werden noch Material-Gemeinkosten aufgeschlagen. ± in 5-€-Schritten.">
                            <h4 className="text-[9px] font-bold text-stone-500 dark:text-gray-500 uppercase tracking-widest mb-1">Mat. EUR</h4>
                            <SteppedEditableField
                                value={inputs.materialPreis}
                                onSave={(v) => setInputs((p: any) => ({ ...p, materialPreis: v }))}
                                step={5}
                                format="currency"
                                className="w-full !text-xs !font-bold !py-1 !px-0.5"
                                formatCurrency={formatCurrency}
                                ariaLabel="Materialpreis"
                                compact
                            />
                        </div>
                        <div className="bg-pe-card rounded-lg p-2 border border-customBeige/50 shadow-[inset_0_2px_10px_rgba(0,0,0,0.5)] text-center" data-tooltip-id="app-tooltip" data-tooltip-content="Gib hier die verbrauchte menge in Gramm/Milliliter ein. ± in 5-g-Schritten.">
                            <h4 className="text-[9px] font-bold text-customBeige uppercase tracking-widest mb-1">Mat. g</h4>
                            <SteppedEditableField
                                value={inputs.materialGramm}
                                onSave={(v) => setInputs((p: any) => ({ ...p, materialGramm: v }))}
                                step={5}
                                format="gramm"
                                className="w-full !text-xs !font-bold !py-1 !px-0.5"
                                ariaLabel="Materialmenge"
                                compact
                            />
                        </div>
                        <div className="bg-pe-tile-header rounded-lg p-2 border border-pe-border dark:border-[#222] shadow-[inset_0_2px_10px_rgba(0,0,0,0.5)] text-center" data-tooltip-id="app-tooltip" data-tooltip-content="Durchschnittlicher Stundenlohn des produktiven Teams.">
                            <h4 className="text-[9px] font-bold text-stone-500 dark:text-gray-500 uppercase tracking-widest mb-1">Team Lohn</h4>
                            <div className="calculated-field w-full !text-sm !font-bold !py-1">{fmtEUR(storeCalc.teamStundenlohn)}</div>
                        </div>
                    </div>

                    <div className="flex flex-row flex-wrap justify-between items-center mt-2 sm:mt-5 gap-2 sm:gap-3"> 
                        <div className="flex items-center gap-1.5 sm:gap-3 text-xs sm:text-base whitespace-nowrap cursor-help min-w-0" data-tooltip-id="app-tooltip" data-tooltip-content="Wähle einen vordefinierten Zuschlag. Der Nettowert wird zum Gewinn addiert."> 
                            <label className="text-[9px] sm:text-sm font-bold text-pe-muted dark:text-gray-300 uppercase tracking-wide shrink-0">Zuschlag</label> 
                            <select value={selectedSurchargeId} onChange={(e: any) => setSelectedSurchargeId(e.target.value)} className="custom-select !p-1 sm:!p-2 !text-xs sm:!text-sm w-28 sm:w-48"> 
                                <option value="">Kein Zuschlag</option> 
                                {(surchargeData || []).map((s: any) => ( 
                                    <option key={s.id} value={s.id}>{s.description}</option> 
                                ))} 
                            </select> 
                            <span className="text-customBeige font-semibold font-numeric text-xs sm:text-base">{fmtEUR(calculations.surchargeNettoValue)}</span> 
                        </div> 
                        <div className="flex items-baseline justify-end whitespace-nowrap text-right tooltip-shift-right" data-tooltip-id="app-tooltip" data-tooltip-content="Gesetztes Ziel für Rücklagen."> 
                            <span className="text-[11px] sm:text-base font-bold text-pe-text">
                                Ziel min. {formatPercent(storeCalc.settings?.global?.Liquiditaet || 0, 0)}
                                <span className="hidden sm:inline text-[10px] sm:text-xs text-pe-muted dark:text-gray-400 sm:ml-4 font-normal"> für Rücklagen und Liquidität</span>
                            </span> 
                        </div> 
                    </div>

                    {/* Mobil: Status-Chips statt schwebender Leuchtbuttons */}
                    {(calculations.surchargeNettoValue > 0 || calculations.totalActivatedDevicePrice > 0 || calculations.totalMaterialCost > 0) && (
                        <div className="sm:hidden flex flex-wrap gap-1.5 mt-2">
                            {calculations.surchargeNettoValue > 0 && (
                                <span className="inline-flex items-center gap-1 px-2 py-1 rounded-md text-[10px] font-black uppercase tracking-wide bg-cyan-900/80 border border-cyan-400/70 text-cyan-100">⚠️ Zuschlag</span>
                            )}
                            {calculations.totalActivatedDevicePrice > 0 && (
                                <span className="inline-flex items-center gap-1 px-2 py-1 rounded-md text-[10px] font-black uppercase tracking-wide bg-purple-900/80 border border-purple-500/70 text-purple-100">⚠️ Geräte</span>
                            )}
                            {calculations.totalMaterialCost > 0 && (
                                <button
                                    type="button"
                                    onClick={onScrollToMaterial}
                                    className="inline-flex items-center gap-1 px-2 py-1 rounded-md text-[10px] font-black uppercase tracking-wide bg-yellow-700/90 border border-yellow-400/70 text-yellow-100"
                                >
                                    ⚠️ Material
                                </button>
                            )}
                        </div>
                    )}
                    
                    <GewinnGauge gewinn={calculations.gewinn} gewinnPercent={calculations.gewinnPercent} formatCurrency={formatCurrency} targetPercent={storeCalc.settings?.global?.Liquiditaet || 12.5} /> 

                    <div className="flex flex-row gap-2 sm:gap-3 mt-2 sm:mt-5 w-full">
                        <button 
                            onClick={onOpenPreislisteModal} 
                            className="flex-1 rounded-lg sm:rounded-xl font-bold py-2 sm:py-3 transition-all shadow-[0_0_10px_rgba(230,194,153,0.3)] hover:shadow-[0_0_20px_rgba(230,194,153,0.6)] uppercase tracking-widest text-[10px] sm:text-sm"
                            style={{ background: '#E6C299', color: '#000000', border: 'none' }}
                        >
                            ➕ Preisliste
                        </button>
                        <button
                            onClick={onOpenPaketpreisModal}
                            className="flex-1 rounded-lg sm:rounded-xl font-bold py-2 sm:py-3 transition-all hover:bg-pe-card uppercase tracking-widest text-[9px] sm:text-xs"
                            style={{ background: '#0f172a', color: '#E6C299', border: '1px solid #E6C299' }}
                        >
                            + Paketpreis{paketDraftCount > 0 ? ` (${paketDraftCount})` : ''}
                        </button>
                        <button 
                            onClick={onOpenMasterTool} 
                            className="flex-1 rounded-lg sm:rounded-xl font-bold py-2 sm:py-3 transition-all hover:bg-pe-card uppercase tracking-widest text-[10px] sm:text-sm"
                            style={{ background: '#0a0a0a', color: '#E6C299', border: '1px solid #E6C299' }}
                        >
                            📋 Ansehen
                        </button>
                    </div>
                    </div>
                </section> 
            </div> 
            <div className="hidden xl:flex flex-shrink-0 flex-col w-full xl:w-96 order-3 xl:order-2"> 
                <div className="carbon-panel carbon-weave-bg w-full"> 
                    <div className="carbon-content p-6">
                        <div className="flex justify-between items-end mb-4 border-b border-pe-border dark:border-[#222] pb-3 gap-3"> 
                            <h3 className="text-lg font-bold text-customBeige uppercase tracking-wide">Material aktivieren</h3> 
                            <div className="flex flex-col items-end gap-1 shrink-0">
                                <button onClick={onScrollToMaterial} className="action-btn !text-xs">Rechner ↓</button>
                                <span className="text-[9px] font-black uppercase tracking-widest text-stone-500 dark:text-slate-500">Preis pro 100&nbsp;ml/g</span>
                            </div>
                        </div> 
                        <div className="space-y-3"> 
                            {(materialData || []).map((m: any) => ( 
                                <div key={m.id} className="flex items-center justify-between text-sm gap-2"> 
                                    <div className="flex items-center gap-3 min-w-0"> 
                                        <input type="checkbox" id={`activator-${m.id}`} checked={(activeMaterialIDs || new Set()).has(m.id)} onChange={() => toggleMaterial(m.id)} /> 
                                        <label htmlFor={`activator-${m.id}`} className="text-pe-muted dark:text-gray-300 truncate">{m.name}</label> 
                                    </div> 
                                    <span className="text-customBeige font-semibold font-numeric whitespace-nowrap shrink-0" title="Umrechnung: Gebinde-EK ÷ Gebindegröße × 100">
                                        {fmtEUR(m.gebinde > 0 ? (m.ekPreis/m.gebinde)*100 : 0)}
                                        <span className="text-[9px] font-bold text-stone-500 dark:text-slate-500 ml-1">/100</span>
                                    </span> 
                                </div> 
                            ))} 
                        </div> 
                        {hasDevicesInStructure && ( 
                            <div className="mt-8 pt-6 border-t border-pe-border dark:border-[#222]"> 
                                <h3 className="text-lg font-bold mb-4 text-customBeige uppercase tracking-wide">Geräte aktivieren</h3> 
                                <div className="space-y-3"> 
                                    {(storeCalc.geraeteListe || []).filter((g: any): g is Geraet => g !== null).map((d: Geraet) => ( 
                                        <div key={d.id} className="flex items-center justify-between text-sm"> 
                                            <div className="flex items-center gap-3"> 
                                                <input type="checkbox" id={`device-activator-${d.id}`} checked={(activeDeviceIDs || new Set()).has(d.id)} onChange={() => toggleDevice(d.id)} /> 
                                                <label htmlFor={`device-activator-${d.id}`} className="text-pe-muted dark:text-gray-300">{d.name}</label> 
                                            </div> 
                                            <span className="text-customBeige font-numeric">Faktor: {d.kostenProzent.toLocaleString('de-DE', { minimumFractionDigits: 1, maximumFractionDigits: 1 })}%</span> 
                                        </div> 
                                    ))} 
                                </div> 
                            </div> 
                        )}
                    </div>
                </div> 
            </div> 
        </div> 
    );
};

const Materialrechner = ({ materialData, onDataChange, sectionRef, formatCurrency }: any) => { 
    const [isEx, setIsEx] = useState(false);
    return ( 
        <section ref={sectionRef} className="carbon-panel carbon-weave-bg mb-6"> 
            <div className="carbon-content p-6">
                <div onClick={() => setIsEx(!isEx)} className="flex justify-between items-center cursor-pointer"> 
                    <h3 className="text-xl font-bold text-customBeige uppercase tracking-wider">Materialrechner</h3> 
                    <span className={`transform transition-transform ${isEx ? 'rotate-180' : ''} text-customBeige`}>▼</span> 
                </div> 
                {isEx && ( 
                    <div className="mt-6 border-t border-pe-border dark:border-[#222] pt-6"> 
                        <div className="overflow-x-auto"> 
                            <table className="w-full compact-table">
                                <thead>
                                    <tr><th className="text-left">Name</th><th>Größe</th><th>EK</th><th>pro 100&nbsp;ml/g</th><th>Aktion</th></tr>
                                </thead>
                                <tbody>
                                    {(materialData || []).map((m: any) => ( 
                                        <tr key={m.id} className="hover:bg-white/5 transition-colors">
                                            <td><EditableField value={m.name} onSave={(v: any) => onDataChange(materialData.map((x: any)=>x.id===m.id?{...x,name:v}:x))} type="text" className="!bg-pe-input dark:!bg-black/50 !text-left" /></td>
                                            <td><EditableField value={m.gebinde} onSave={(v: any) => onDataChange(materialData.map((x: any)=>x.id===m.id?{...x,gebinde:v}:x))} format="gramm" className="!bg-pe-input dark:!bg-black/50" /></td>
                                            <td><EditableField value={m.ekPreis} onSave={(v: any) => onDataChange(materialData.map((x: any)=>x.id===m.id?{...x,ekPreis:v}:x))} format="currency" formatCurrency={formatCurrency} className="!bg-pe-input dark:!bg-black/50" /></td>
                                            <td className="text-customBeige font-bold text-center">{symbolToText(formatCurrency(m.gebinde>0?(m.ekPreis/m.gebinde)*100:0))}</td>
                                            <td><button onClick={()=>onDataChange(materialData.filter((x:any)=>x.id!==m.id))} className="remove-btn mx-auto">🗑️</button></td>
                                        </tr> 
                                    ))}
                                </tbody>
                            </table>
                        </div> 
                        <button onClick={()=>onDataChange([...(materialData || []),{id:'m'+Date.now(),name:'Neu',gebinde:100,ekPreis:10}])} className="action-btn mt-6">+ Neue Zeile</button> 
                    </div> 
                )} 
            </div>
        </section> 
    );
};

const Spezialzuschlaege = ({ surchargeData, onDataChange, formatCurrency }: any) => { 
    const [isEx, setIsEx] = useState(false);
    return ( 
        <section className="carbon-panel carbon-weave-bg mb-6"> 
            <div className="carbon-content p-6">
                <div onClick={() => setIsEx(!isEx)} className="flex justify-between items-center cursor-pointer"> 
                    <h3 className="text-xl font-bold text-customBeige uppercase tracking-wider">Spezialzuschläge</h3> 
                    <span className={`transform transition-transform ${isEx ? 'rotate-180' : ''} text-customBeige`}>▼</span> 
                </div> 
                {isEx && ( 
                    <div className="mt-6 border-t border-pe-border dark:border-[#222] pt-6"> 
                        <table className="w-full text-left compact-table">
                            <thead>
                                <tr><th className="text-left">Beschreibung</th><th>Preis</th><th>Aktion</th></tr>
                            </thead>
                            <tbody>
                                {(surchargeData || []).map((s: any) => ( 
                                    <tr key={s.id} className="hover:bg-white/5 transition-colors">
                                        <td><EditableField value={s.description} onSave={(v: any) => onDataChange(surchargeData.map((x: any)=>x.id===s.id?{...x,description:v}:x))} type="text" className="!bg-pe-input dark:!bg-black/50 !text-left" /></td>
                                        <td><EditableField value={s.price} onSave={(v: number)=>onDataChange(surchargeData.map((x: any)=>x.id===s.id?{...x,price:v}:x))} format="currency" formatCurrency={formatCurrency} className="!bg-pe-input dark:!bg-black/50" /></td>
                                        <td><button onClick={()=>onDataChange(surchargeData.filter((x:any)=>x.id!==s.id))} className="remove-btn mx-auto">🗑️</button></td>
                                    </tr>
                                ))}
                            </tbody>
                        </table> 
                        <button onClick={()=>onDataChange([...(surchargeData || []), { id: 's' + Date.now(), description: 'Neu', price: 15.00 }])} className="action-btn mt-6">+ Neuer Zuschlag</button> 
                    </div> 
                )} 
            </div>
        </section> 
    );
};

const ZeitparameterReferenzen = () => {
    const [isEx, setIsEx] = useState(false);
    return ( 
        <section className="carbon-panel carbon-weave-bg w-full block"> 
            <div className="carbon-content p-6">
                <div onClick={() => setIsEx(!isEx)} className="flex items-center justify-between cursor-pointer py-1 w-full border-b border-pe-border dark:border-[#222] pb-4"> 
                    <h2 className="text-xl font-bold text-customBeige m-0 p-0 text-left w-full block uppercase tracking-wider">Zeitparameter Referenzen</h2> 
                    <span className={`transform transition-transform ${isEx ? 'rotate-180' : ''} text-customBeige ml-4`}>▼</span> 
                </div> 
                {isEx && ( 
                    <div className="mt-6 space-y-6 text-pe-muted dark:text-gray-300 w-full block"> 
                        <div className="w-full text-left"> 
                            <h3 className="font-bold text-pe-text mb-3 text-left block uppercase tracking-widest text-xs">Haarschnitte</h3> 
                            <div className="space-y-2 w-full max-w-2xl text-left block"> 
                                <div className="flex justify-between w-full border-b border-[#1a1a1a] pb-1"><span>Herren mit Waschen</span><span className="font-numeric text-customBeige">30 - 35 min.</span></div> 
                                <div className="flex justify-between w-full border-b border-[#1a1a1a] pb-1"><span>Damen kurz (Waschen & Föhnen)</span><span className="font-numeric text-customBeige">ca. 45 min.</span></div> 
                                <div className="flex justify-between w-full border-b border-[#1a1a1a] pb-1"><span>Damen mittel (Waschen & Föhnen)</span><span className="font-numeric text-customBeige">ca. 60 min.</span></div> 
                                <div className="flex justify-between w-full border-b border-[#1a1a1a] pb-1"><span>Damen lang (Waschen & Föhnen)</span><span className="font-numeric text-customBeige">ca. 75 min.</span></div> 
                            </div> 
                            <p className="mt-4 text-xs text-left bg-pe-tile-header p-3 rounded-xl border border-pe-border dark:border-[#222] shadow-inner max-w-2xl inline-block text-pe-muted dark:text-gray-400"> <span className="font-bold text-pe-text">Unsere Empfehlung:</span> Nicht nach Länge, sondern <span className="text-customBeige underline">ausschließlich nach Zeit</span> abrechnen! </p> 
                        </div> 
                        <div className="border-t border-pe-border dark:border-[#222] pt-6 w-full text-left"> 
                            <h3 className="font-bold text-pe-text mb-3 text-left block uppercase tracking-widest text-xs">Haarfarben</h3> 
                            <div className="space-y-3 w-full max-w-2xl text-left block"> 
                                <div className="flex justify-between w-full border-b border-[#1a1a1a] pb-2"><span>Ansatzfarbe (30-40g)</span><div className="text-right"><span className="font-numeric text-customBeige block">mind. 40 - 45 min.</span><span className="block text-[10px] text-stone-500 dark:text-gray-500 uppercase tracking-widest mt-1">mit Waschen & Absäuern</span></div></div> 
                                <div className="flex justify-between w-full border-b border-[#1a1a1a] pb-2"><span>Strähnen Oberkopf (30-40g)</span><div className="text-right"><span className="font-numeric text-customBeige block">mind. 60 min.</span><span className="block text-[10px] text-stone-500 dark:text-gray-500 uppercase tracking-widest mt-1">mit Waschen & Absäuern</span></div></div> 
                            </div> 
                        </div> 
                        <div className="border-t border-pe-border dark:border-[#222] pt-6 w-full text-left"> 
                            <h3 className="font-bold text-pe-text mb-3 text-left block uppercase tracking-widest text-xs">Materialeinsatz</h3> 
                            <div className="flex justify-between w-full max-w-2xl text-left block bg-pe-tile-header p-3 rounded-xl border border-pe-border dark:border-[#222] shadow-inner"><span>Stundenverrechnungssatz inkl. Material</span><span className="font-numeric text-customBeige font-bold">ca. 50g pro Std.</span></div> 
                        </div>
                    </div> 
                )} 
            </div>
        </section> 
    );
};

export default function KalkulatorPage() {
    const storeCalc = useCalculationsSelector();
    const { clientData, setClientData, settings, captureState } = useAppStore();
    const isGodMode = !!useAdminStore((s) => s.impersonatedClientId) || (typeof sessionStorage !== 'undefined' && !!sessionStorage.getItem('GOD_MODE_ID'));
    const formatCurrency = storeCalc.formatCurrency;

    const fallbackKalk = useMemo(() => ({
        inputs: { bisherigerPreis: 0, neuerPreis: 0, bedienzeit: 0, materialPreis: 0, materialGramm: 0 },
        selectedSurchargeId: '',
        activeMaterialIds: [],
        activeDeviceIds: [],
        manualGeraeteRates: {},
        useEchterStundensatz: false,
        echterStundensatz: 0,
        useEchterStundensatzMat: false, 
        echterStundensatzMat: 0,
        barometerStundenfaktor: 0,
        barometerRuecklage: 0,
        barometerAnpassung: 0,
        hasConfirmedRates: false,
        materialListe: undefined,
        surchargeListe: undefined,
        // Standard-Template nur in der Akte — Werte immer 0 bis Coach pflegt
        priceParameterListe: [
            { id: 'p1', desc: '10g inkl. Arbeitszeit', preis: 0, ruecklage: 0, anpassung: 0 },
            { id: 'p2', desc: 'Ansatzfarbe 30g 45min.', preis: 0, ruecklage: 0, anpassung: 0 },
            { id: 'p3', desc: 'Ansatzfarbe 45g 45min.', preis: 0, ruecklage: 0, anpassung: 0 },
            { id: 'p4', desc: 'Stundensatz inkl. 50g Material', preis: 0, ruecklage: 0, anpassung: 0 },
        ],
    }), []);

    const kalkState = useMemo(() => ({ ...fallbackKalk, ...(clientData.kalkulator || {}) }), [fallbackKalk, clientData.kalkulator]);
    const inputs = useMemo(() => ({ ...fallbackKalk.inputs, ...(kalkState.inputs || {}) }), [fallbackKalk.inputs, kalkState.inputs]);
    
    const selectedSurchargeId = kalkState.selectedSurchargeId || '';
    const actMat = useMemo(() => new Set<string>(kalkState.activeMaterialIds || []), [kalkState.activeMaterialIds]);
    const actDev = useMemo(() => new Set<string>(kalkState.activeDeviceIds || []), [kalkState.activeDeviceIds]);
    const manualGeraeteRates = useMemo(() => kalkState.manualGeraeteRates || {}, [kalkState.manualGeraeteRates]);

    const materialData = useMemo(() => kalkState.materialListe || settings.materialListe || [], [kalkState.materialListe, settings.materialListe]);
    const surchargeData = useMemo(() => kalkState.surchargeListe || settings.surchargeListe || [], [kalkState.surchargeListe, settings.surchargeListe]);

    // Ausschließlich Mandanten-Admin-Bereich — keine globalen Settings
    const adminParamData = useMemo(() => {
        const fromClient = kalkState.priceParameterListe;
        return Array.isArray(fromClient) && fromClient.length > 0 ? fromClient : (fallbackKalk.priceParameterListe || []);
    }, [kalkState.priceParameterListe, fallbackKalk.priceParameterListe]);
    
    const stundenfaktor = Number(kalkState.barometerStundenfaktor ?? 0);
    const basisRuecklage = Number(kalkState.barometerRuecklage ?? 0);
    const basisAnpassung = Number(kalkState.barometerAnpassung ?? 0);

    const baseMatParam = useMemo(() => {
        if (!adminParamData || adminParamData.length === 0) return null;
        const found = adminParamData.find((p:any) => p.desc.toLowerCase().includes('stundensatz') || p.desc.toLowerCase().includes('verrechnungssatz'));
        if (found) return found;
        return adminParamData.reduce((max:any, p:any) => p.preis > max.preis ? p : max, adminParamData[0]);
    }, [adminParamData]);

    const baseMatGrams = useMemo(() => {
        if (!baseMatParam || !baseMatParam.desc) return 50;
        const match = baseMatParam.desc.match(/(\d+)\s*g/i);
        return match ? parseInt(match[1], 10) : 50;
    }, [baseMatParam]);

    const targetMatPreis = baseMatParam ? baseMatParam.preis : 0;
    const targetMatRuecklage = baseMatParam ? baseMatParam.ruecklage : 0;

    const [isAdmin, setIsAdmin] = useState(false);
    const [showPin, setShowPin] = useState(false);
    const [showPreislisteModal, setShowPreislisteModal] = useState(false);
    const [showPaketpreisModal, setShowPaketpreisModal] = useState(false);
    const [paketDraft, setPaketDraft] = useState(() => loadPaketpreisDraft());
    const [showMasterTool, setShowMasterTool] = useState(false);
    const [showNagModal, setShowNagModal] = useState(false);
    const [showBeratungsBarometer, setShowBeratungsBarometer] = useState(false);

    const isSoloActive = isSoloModeActive(clientData);
    const effectiveSozialabgabenPercent = isSoloActive ? 0 : (storeCalc.avgSozialabgabenPercent || 0);

    const mitarbeiterData = useMemo(() => {
        return (storeCalc.personalData || []).map((ma: Partial<EmployeeData>) => {
            const employeeId = ma.id || '';
            const usesDevices = !!ma.hasGeraete || !!(storeCalc.clientData?.mitarbeiterLeistung?.[employeeId]?.selectedDeviceIds?.length);
            return { name: ma.name || 'Unbekannt', stundensatz: storeCalc.calculatedMitarbeiterLeistung?.[employeeId]?.requiredRate75 || 0, hasGeraete: usesDevices };
        });
    }, [storeCalc.personalData, storeCalc.calculatedMitarbeiterLeistung, storeCalc.clientData?.mitarbeiterLeistung]);

    const materialRef = useRef<HTMLElement>(null);
    const adminRef = useRef<HTMLDivElement>(null);

    // Alte Demo-Reste (10/65/75/120 + 12,5% Rücklage) ohne Coach-Barometer → Nullen
    useEffect(() => {
        const barometer = Number(kalkState.barometerStundenfaktor ?? 0);
        if (barometer > 0 || kalkState.hasConfirmedRates) return;
        const list = kalkState.priceParameterListe;
        if (!Array.isArray(list) || list.length === 0) return;

        const DEMO_PREISE = new Set([10, 65, 75, 120]);
        const looksLikeLegacyDemo =
            list.some((p: any) => DEMO_PREISE.has(Number(p.preis))) &&
            list.every((p: any) => {
                const preis = Number(p.preis) || 0;
                const rueck = Number(p.ruecklage) || 0;
                return (preis === 0 || DEMO_PREISE.has(preis)) && (rueck === 0 || rueck === 12.5);
            });
        if (!looksLikeLegacyDemo) return;

        setClientData((prev: any) => ({
            ...prev,
            kalkulator: {
                ...(prev?.kalkulator || {}),
                priceParameterListe: list.map((p: any) => ({
                    ...p,
                    preis: 0,
                    ruecklage: 0,
                    anpassung: 0,
                })),
            },
        }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [kalkState.barometerStundenfaktor, kalkState.hasConfirmedRates, kalkState.priceParameterListe]);

    useEffect(() => {
        if (kalkState.hasConfirmedRates) {
            setShowNagModal(false);
            return;
        }

        // Nur naggen, wenn Coach echte Basis-Werte gesetzt hat (> 0)
        const coachHasSetRates = stundenfaktor > 0 || targetMatPreis > 0;
        if (!coachHasSetRates) {
            setShowNagModal(false);
            return;
        }
        
        const initTimer = setTimeout(() => setShowNagModal(true), 2000);
        
        const nagInterval = setInterval(() => {
            setShowNagModal(prev => {
                if (!prev) return true;
                return prev;
            });
        }, 30000);

        return () => {
            clearTimeout(initTimer);
            clearInterval(nagInterval);
        };
    }, [kalkState.hasConfirmedRates, stundenfaktor, targetMatPreis]);

    useEffect(() => {
        if (isAdmin && adminRef.current) adminRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' }); 
    }, [isAdmin]);

    const updateKalkState = useCallback((newKalk: any) => {
        captureState();
        setClientData(prev => ({ ...prev, kalkulator: { ...kalkState, ...newKalk } }));
    }, [setClientData, kalkState, captureState]);

    const setInputs = useCallback((updater: any) => {
        const nextInputs = typeof updater === 'function' ? updater(inputs) : updater;
        updateKalkState({ inputs: nextInputs });
    }, [inputs, updateKalkState]);

    const setSelectedSurchargeId = useCallback((val: string) => updateKalkState({ selectedSurchargeId: val }), [updateKalkState]);

    const toggleMaterial = useCallback((targetId: string) => {
        const nextIds = new Set(Array.from(actMat));
        if (nextIds.has(targetId)) nextIds.delete(targetId); else nextIds.add(targetId); 
        updateKalkState({ activeMaterialIds: Array.from(nextIds) });
    }, [actMat, updateKalkState]);

    const toggleDevice = useCallback((targetId: string) => {
        const nextIds = new Set(Array.from(actDev));
        if (nextIds.has(targetId)) nextIds.delete(targetId); else nextIds.add(targetId); 
        updateKalkState({ activeDeviceIds: Array.from(nextIds) });
    }, [actDev, updateKalkState]);

    const setManualGeraeteRates = useCallback((updater: any) => {
        const nextRates = typeof updater === 'function' ? updater(manualGeraeteRates) : updater;
        updateKalkState({ manualGeraeteRates: nextRates });
    }, [manualGeraeteRates, updateKalkState]);

    const setMaterialData = (newList: any) => { updateKalkState({ materialListe: newList }); };
    const setSurchargeData = (newList: any) => { updateKalkState({ surchargeListe: newList }); };
    const setAdminParamData = (newList: any) => { updateKalkState({ priceParameterListe: newList }); };

    const updateAdminDesc = (targetId: string, val: string) => setAdminParamData(adminParamData.map((item: any) => item.id === targetId ? { ...item, desc: val } : item));
    const updateAdminPreis = (targetId: string, val: number) => setAdminParamData(adminParamData.map((item: any) => item.id === targetId ? { ...item, preis: val } : item));
    const updateAdminRuecklage = (targetId: string, val: number) => setAdminParamData(adminParamData.map((item: any) => item.id === targetId ? { ...item, ruecklage: val } : item));
    const updateAdminAnpassung = (targetId: string, val: number) => setAdminParamData(adminParamData.map((item: any) => item.id === targetId ? { ...item, anpassung: val } : item));
    const removeAdminParam = (targetId: string) => setAdminParamData(adminParamData.filter((item: any) => item.id !== targetId));
    const assignLiveValues = (targetId: string, pLive: number, rLive: number, aLive: number) => setAdminParamData(adminParamData.map((item: any) => item.id === targetId ? { ...item, preis: pLive, ruecklage: rLive, anpassung: aLive } : item));

    const geraeteDisplayData = useMemo(() => {
        return (storeCalc.geraeteListe || []).filter((g: any): g is Geraet => g !== null).map((g: Geraet) => ({ id: g.id, desc: g.name, preis: manualGeraeteRates[g.id] || 0 }));
    }, [storeCalc.geraeteListe, manualGeraeteRates]);

    const calc = useMemo(() => {
        const { bisherigerPreis, neuerPreis, bedienzeit, materialPreis, materialGramm } = inputs;
        const mwst = (storeCalc.mwstSatz || 0) / 100; 
        const gk = (storeCalc.gemeinkostenfaktor || 0);
        // Kanonisch: Anteil am Netto-Monatsumsatz (wie Selektor unprodUnternehmerlohnPercent)
        const ul = (storeCalc.unprodUnternehmerlohnPercent || 0) / 100;
        const vl = (storeCalc.settings?.global?.Verlust_1 || 0) / 100;

        let mSum = 0; let mCnt = 0;
        actMat.forEach((id: string) => { const m = materialData.find((x: any) => x.id === id); if(m && m.gebinde > 0) { mSum += (m.ekPreis/m.gebinde)*100; mCnt++; } });
        const avg100 = mCnt > 0 ? mSum/mCnt : 0;
        // Kalkulator-Material (Haarfarbe/Wareneinsatz) = Warenaufschlag VK (Default 1.30).
        // Produktrechner nutzt separat DL 1.05 — nicht vermischen.
        const wawiVk = Number(storeCalc.settings?.global?.Warenwirtschaftsaufschlag_VK);
        const matFaktor = Number.isFinite(wawiVk) && wawiVk > 0 ? wawiVk : 1.3;
        const matCost = ((avg100/100)*materialGramm + materialPreis)*matFaktor;
        const mwstVal = neuerPreis - (neuerPreis/(1+mwst)); const netto = neuerPreis - mwstVal;
        
        let dPerc = 0; actDev.forEach((id: string) => { const d = (storeCalc.geraeteListe || []).find((x: any) => x?.id === id); if(d) dPerc += d.kostenProzent; });
        const devCostTotal = netto * (dPerc / 100);
        const sPrice = (surchargeData.find((x: any) => x.id === selectedSurchargeId)?.price || 0) / (1 + mwst);
        
        const uebrig = Number((netto - matCost - devCostTotal - (netto*gk) - (netto*ul) - (netto*vl) + sPrice).toFixed(2));
        const lohnBasis = Number((storeCalc.teamStundenlohn * (bedienzeit / 60)).toFixed(2)); 
        const urlaubVal = Number((lohnBasis * (storeCalc.lohnfortzahlungPercent / 100)).toFixed(2));
        
        // 💉 CHIRURGIE-FIX: Sozialversicherung wird über die Variable 'effectiveSozialabgabenPercent' gesteuert (0% bei Solo)
        const sozialVal = Number(((lohnBasis + urlaubVal) * (effectiveSozialabgabenPercent / 100)).toFixed(2));
        
        const totalLohn = Number((lohnBasis + urlaubVal + sozialVal).toFixed(2));
        const finalGewinn = Number((uebrig - totalLohn).toFixed(2));
        const currentAnpassung = bisherigerPreis > 0 ? ((neuerPreis / bisherigerPreis) - 1) * 100 : 0;
        
        return { 
            mwstValue: mwstVal, nettoNachMwst: netto, totalMaterialCost: matCost, totalActivatedDevicePrice: devCostTotal, 
            totalActivatedDevicePricePercent: dPerc, gemeinkostenValue: netto*gk, unternehmerlohnValue: netto*ul, 
            verlustValue: netto*vl, uebrigFuerLohn: uebrig, lohnkostenValue: totalLohn, gewinn: finalGewinn, 
            gewinnPercent: netto > 0 ? (finalGewinn / netto) * 100 : 0, surchargeNettoValue: sPrice, 
            totalMaterialCostPercent: netto > 0 ? (matCost / netto) * 100 : 0, currentAnpassung 
        };
    }, [inputs, selectedSurchargeId, materialData, actMat, storeCalc.geraeteListe, actDev, surchargeData, storeCalc.mwstSatz, storeCalc.gemeinkostenfaktor, storeCalc.unprodUnternehmerlohnPercent, storeCalc.settings?.global?.Verlust_1, storeCalc.settings?.global?.Warenwirtschaftsaufschlag_VK, storeCalc.teamStundenlohn, storeCalc.lohnfortzahlungPercent, effectiveSozialabgabenPercent]);

    const showGeraeteUI = (storeCalc.geraeteListe || []).length > 0;

    const handleSavePreisliste = (data: any) => {
        captureState();
        setClientData(prev => ({
            ...prev,
            preisliste: [
                ...(prev.preisliste || []), 
                { ...data, gewinn: calc.gewinn, gewinnPercent: calc.gewinnPercent, id: 'pl_' + Date.now() + Math.random().toString(36).substring(2, 9), createdAt: Date.now() }
            ]
        }));
        setShowPreislisteModal(false);
    };

    const handleSavePaketpreis = (data: any) => {
        captureState();
        const faktoren = {
            mwstSatz: storeCalc.mwstSatz || 0,
            gemeinkostenfaktor: storeCalc.gemeinkostenfaktor || 0,
            unternehmerlohnAnteil: (storeCalc.unprodUnternehmerlohnPercent || 0) / 100,
            verlustAnteil: (Number(storeCalc.settings?.global?.Verlust_1 ?? storeCalc.verlustPercent) || 0) / 100,
            teamStundenlohn: storeCalc.teamStundenlohn || 0,
            lohnfortzahlungPercent: storeCalc.lohnfortzahlungPercent || 0,
            sozialPercent: effectiveSozialabgabenPercent || 0,
        };
        const services = (data.packageServices || []).map((s: any) => {
            const line = berechneRuecklage(faktoren, {
                brutto: Number(s.einzelpreisBrutto) || 0,
                minuten: Number(s.dauerMinuten) || 0,
                materialNetto: Number(s.materialKostenNetto) || 0,
                geraeteNetto: Number(s.geraeteKostenNetto) || 0,
            });
            return { ...s, gewinn: line.gewinn, gewinnPercent: line.gewinnPercent };
        });
        const paket = berechneRuecklage(faktoren, {
            brutto: Number(data.finalerPreis) || 0,
            minuten: Number(data.gesamtDauerMinuten || data.bedienzeit) || 0,
            materialNetto: Number(data.materialEinsatz) || 0,
            geraeteNetto: Number(data.geräteEinsatz) || 0,
        });
        setClientData(prev => ({
            ...prev,
            preisliste: [
                ...(prev.preisliste || []),
                {
                    ...data,
                    packageServices: services,
                    gewinn: paket.gewinn,
                    gewinnPercent: paket.gewinnPercent,
                    id: 'pl_' + Date.now() + Math.random().toString(36).substring(2, 9),
                    createdAt: Date.now(),
                }
            ]
        }));
        setShowPaketpreisModal(false);
        setPaketDraft(emptyPaketpreisDraft());
        clearPaketpreisDraft();
    };

    useEffect(() => {
        savePaketpreisDraft(paketDraft);
        if (String(paketDraft.titel || '').trim()) rememberPaketTitel(paketDraft.titel);
    }, [paketDraft]);

    const aktuelleLeistungName = (() => {
        const hit = (surchargeData || []).find((s: any) => s.id === selectedSurchargeId);
        const label = hit?.description ? String(hit.description).trim() : '';
        return label || 'Aktuelle Kalkulation';
    })();

    return (
        <div className="min-h-screen bg-pe-bg dark:bg-[#030303] text-pe-text p-4 pb-32 relative">
            <CustomStyles />
            <div className="no-print-container mx-auto max-w-screen-2xl">
                <div className="flex flex-col lg:flex-row justify-center items-start gap-8 mb-8">
                    <div className={`w-full flex flex-col gap-8 min-w-0 ${!showGeraeteUI ? 'lg:max-w-4xl' : 'flex-grow'}`}>
                        <PreisBarometer 
                            stundenfaktor={stundenfaktor} 
                            adminParamData={adminParamData} 
                            showGeraeteSection={showGeraeteUI} 
                            kalkRuecklage={basisRuecklage} 
                            onOpenAdmin={() => setShowPin(true)} 
                            formatCurrency={formatCurrency} 
                            useEchterStundensatz={kalkState.useEchterStundensatz} 
                            setUseEchterStundensatz={(v: boolean) => updateKalkState({ useEchterStundensatz: v, hasConfirmedRates: false })} 
                            echterStundensatz={kalkState.echterStundensatz} 
                            setEchterStundensatz={(v: number) => updateKalkState({ echterStundensatz: v })} 
                            useEchterStundensatzMat={kalkState.useEchterStundensatzMat} 
                            setUseEchterStundensatzMat={(v: boolean) => updateKalkState({ useEchterStundensatzMat: v, hasConfirmedRates: false })} 
                            echterStundensatzMat={kalkState.echterStundensatzMat} 
                            setEchterStundensatzMat={(v: number) => updateKalkState({ echterStundensatzMat: v })} 
                            baseMatParam={baseMatParam}
                            targetMatPreis={targetMatPreis}
                            targetMatRuecklage={targetMatRuecklage}
                            hasConfirmedRates={kalkState.hasConfirmedRates}
                            onTriggerNag={() => setShowNagModal(true)}
                            onResetConfirmation={() => updateKalkState({ hasConfirmedRates: false })}
                            baseMatGrams={baseMatGrams}
                            storeCalc={storeCalc}
                            isGodMode={isGodMode}
                            onOpenBeratungsBarometer={() => setShowBeratungsBarometer(true)}
                        />
                        <ZeitparameterReferenzen />
                    </div>
                    {showGeraeteUI && <GeraeteDisplay geraeteData={geraeteDisplayData} formatCurrency={formatCurrency} />}
                </div>
                
                <hr className="border-[#1a1a1a] my-4 sm:my-10" />
                
                {/* 💉 CHIRURGIE-FIX: Übergabe der bereinigten SV an den Hauptkalkulator für das UI */}
                <HauptKalkulator 
                    materialData={materialData} 
                    surchargeData={surchargeData} 
                    onScrollToMaterial={()=>materialRef.current?.scrollIntoView({behavior:'smooth'})} 
                    inputs={inputs} 
                    setInputs={setInputs} 
                    selectedSurchargeId={selectedSurchargeId} 
                    setSelectedSurchargeId={setSelectedSurchargeId} 
                    activeMaterialIDs={actMat} 
                    toggleMaterial={toggleMaterial} 
                    activeDeviceIDs={actDev} 
                    toggleDevice={toggleDevice} 
                    calculations={calc} 
                    mitarbeiterData={mitarbeiterData} 
                    storeCalc={storeCalc} 
                    onOpenPreislisteModal={() => setShowPreislisteModal(true)}
                    onOpenPaketpreisModal={() => {
                        setPaketDraft((prev) => {
                            if (String(prev?.titel || '').trim()) return prev;
                            if (!(prev?.services || []).length) return prev;
                            const last = loadLetzterPaketTitel();
                            return last ? { ...prev, titel: last } : prev;
                        });
                        setShowPaketpreisModal(true);
                    }}
                    paketDraftCount={(paketDraft.services || []).length}
                    onOpenMasterTool={() => setShowMasterTool(true)} 
                    geraeteDisplayData={geraeteDisplayData}
                    effectiveSozialabgabenPercent={effectiveSozialabgabenPercent} 
                />
                
                <div className="space-y-8 mt-10 max-w-4xl mx-auto w-full"> 
                    <Materialrechner materialData={materialData} onDataChange={setMaterialData} sectionRef={materialRef} formatCurrency={formatCurrency} /> 
                    <Spezialzuschlaege surchargeData={surchargeData} onDataChange={setSurchargeData} formatCurrency={formatCurrency} /> 
                </div> 
                
                {isAdmin && (
                    <div ref={adminRef} className="mt-16 pt-8 border-t-2 border-pe-border-strong">
                        <div className="flex justify-between items-center mb-6">
                            <h2 className="text-3xl font-bold text-customBeige uppercase tracking-tight">Preis-Parameter (Liste)</h2>
                            <div className="flex gap-4 items-center">
                                <div className="bg-pe-sunken px-5 py-3 rounded-xl border border-pe-border dark:border-[#222] flex gap-6 items-center shadow-inner">
                                    <span className="text-stone-500 dark:text-gray-500 font-bold text-xs uppercase tracking-widest">Live-Check:</span>
                                    <div className="flex items-center gap-4"><span className="text-pe-text font-numeric font-bold text-lg">{symbolToText(formatCurrency(inputs.neuerPreis))}</span><span className="text-stone-300 dark:text-gray-700">|</span><span className="text-blue-700 dark:text-blue-400 font-numeric font-bold text-lg">{formatPercent(calc.gewinnPercent)}</span><span className="text-stone-300 dark:text-gray-700">|</span><span className="text-green-700 dark:text-green-500 font-numeric font-bold text-lg">{formatPercent(calc.currentAnpassung)}</span></div>
                                </div>
                                <button onClick={() => {
                                    updateKalkState({ hasConfirmedRates: false, useEchterStundensatz: false, useEchterStundensatzMat: false });
                                    setShowNagModal(true);
                                }} className="action-btn !bg-orange-600 hover:!bg-orange-500 !px-4 !py-3 !text-white !border-orange-500 font-bold" title="Setzt die Modal-Bestätigung zurück">🔄 Modal Reset</button>
                                <button onClick={()=>setIsAdmin(false)} className="action-btn !bg-red-600 hover:!bg-red-500 !text-white !px-6 !py-3 !border-red-500 font-bold">Schließen</button>
                            </div>
                        </div>
                        <div className="carbon-panel carbon-weave-bg p-8 mt-6">
                            <div className="carbon-content space-y-10">
                                <section> 
                                    <h3 className="text-sm font-bold text-customBeige mb-4 uppercase tracking-wider">Globale Basis-Kalkulation (Nur für Barometer)</h3>
                                    <div className="overflow-hidden rounded-xl border border-pe-border dark:border-[#222] mb-3 shadow-inner">
                                        <table className="w-full compact-table bg-pe-tile-header">
                                            <thead><tr><th className="text-left">Bezeichnung</th><th>Stundenfaktor EUR</th><th>Ø Rücklage</th><th>Ø Anpassung</th><th>Zuweisen</th></tr></thead>
                                            <tbody>
                                                <tr className="bg-transparent hover:bg-white/5 transition-colors">
                                                    <td className="text-pe-muted dark:text-gray-300 font-medium px-4">Basis-Stundenfaktor (Ziel)</td>
                                                    <td><EditableField value={stundenfaktor} onSave={(v: number) => updateKalkState({ barometerStundenfaktor: v })} format="currency" className="!bg-pe-input dark:!bg-black !text-pe-text dark:!text-white font-bold" formatCurrency={formatCurrency} /></td>
                                                    <td><EditableField value={basisRuecklage} onSave={(v: number) => updateKalkState({ barometerRuecklage: v })} format="percent" className="!text-blue-700 dark:!text-blue-400 font-bold !bg-pe-input dark:!bg-black" /></td>
                                                    <td><EditableField value={basisAnpassung} onSave={(v: number) => updateKalkState({ barometerAnpassung: v })} format="percent" className="!text-green-700 dark:!text-green-500 font-bold !bg-pe-input dark:!bg-black" /></td>
                                                    <td className="text-center"><button onClick={() => updateKalkState({ barometerStundenfaktor: inputs.neuerPreis, barometerRuecklage: calc.gewinnPercent, barometerAnpassung: calc.currentAnpassung })} className="bg-blue-600 hover:bg-blue-500 text-white rounded-full w-8 h-8 flex items-center justify-center mx-auto transition-transform active:scale-90 shadow-lg border-none" title="Import">⬇️</button></td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div className="text-xs text-orange-400 bg-orange-950/30 p-3 border border-orange-800/50 rounded-xl inline-block shadow-inner">
                                        <strong>WICHTIG:</strong> Diese Werte verändern nur die Anzeige im Barometer oben. Die globalen Salon-Ziele in der Mandanten-Akte bleiben unberührt!
                                    </div>
                                </section>
                                <section> 
                                    <div className="overflow-hidden rounded-xl border border-pe-border dark:border-[#222] shadow-inner bg-pe-tile-header">
                                        <table className="w-full compact-table">
                                            <thead><tr><th className="text-left">Beschreibung</th><th>Preis</th><th>Rücklage</th><th>Anpassung</th><th>Zuweisen</th><th>Löschen</th></tr></thead>
                                            <tbody>
                                                {(adminParamData).map((item: any) => ( 
                                                    <tr key={item.id} className="hover:bg-white/5 transition-colors">
                                                        <td><EditableField value={item.desc} onSave={(v:string)=>updateAdminDesc(item.id, v)} type="text" className="!bg-pe-input dark:!bg-black !text-left !px-4" /></td>
                                                        <td><EditableField value={item.preis} onSave={(v:number)=>updateAdminPreis(item.id, v)} format="currency" className="!bg-pe-input dark:!bg-black" formatCurrency={formatCurrency} /></td>
                                                        <td><EditableField value={item.ruecklage} onSave={(v:number)=>updateAdminRuecklage(item.id, v)} format="percent" className="!bg-pe-input dark:!bg-black !text-blue-700 dark:!text-blue-400 font-bold" /></td>
                                                        <td><EditableField value={item.anpassung} onSave={(v:number)=>updateAdminAnpassung(item.id, v)} format="percent" className="!bg-pe-input dark:!bg-black !text-green-700 dark:!text-green-500 font-bold" /></td>
                                                        <td className="text-center"><button onClick={()=>assignLiveValues(item.id, inputs.neuerPreis, calc.gewinnPercent, calc.currentAnpassung)} className="bg-blue-600 hover:bg-blue-500 text-white rounded-full w-8 h-8 flex items-center justify-center mx-auto transition-transform active:scale-90 border-none">⬇️</button></td>
                                                        <td className="text-center"><button onClick={()=>removeAdminParam(item.id)} className="remove-btn mx-auto">🗑️</button></td>
                                                    </tr> 
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                    <button onClick={()=>setAdminParamData([...(adminParamData), { id: 'p' + Date.now(), desc: 'Freifeld', preis: 0, ruecklage: 0, anpassung: 0 }])} className="action-btn !text-xs mt-4 font-bold">+ Freifeld hinzufügen</button>
                                </section>
                                <section className="max-w-md border-t border-pe-border dark:border-[#222] pt-8"> 
                                    <h3 className="text-sm font-bold text-customBeige mb-4 uppercase tracking-wider">Geräte-Stundensätze (Rein Informativ)</h3>
                                    <div className="overflow-hidden rounded-xl border border-pe-border dark:border-[#222] shadow-inner bg-pe-tile-header">
                                        <table className="w-full compact-table">
                                            <thead><tr><th className="text-left px-4">Gerät Name</th><th className="w-40 text-center">Eigener Stundensatz</th></tr></thead>
                                            <tbody>
                                                {(storeCalc.geraeteListe || []).filter((g: any): g is Geraet => g !== null).map((g: Geraet) => (
                                                    <tr key={g.id} className="hover:bg-white/5">
                                                        <td className="px-4 text-pe-muted dark:text-gray-300 font-medium">{g.name}</td>
                                                        <td className="p-2"><EditableField value={manualGeraeteRates[g.id] || 0} onSave={(v: number) => setManualGeraeteRates((prev: any) => ({ ...prev, [g.id]: v }))} format="currency" className="!bg-pe-input dark:!bg-black !w-full border-pe-border-strong focus:border-customBeige" formatCurrency={formatCurrency} /></td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </section>
                            </div>
                        </div>
                    </div>
                )}
            </div>

            {/* Schwebende Warn-Buttons: nur Desktop — mobil liegen Status-Chips im Kalkulator */}
            <div className="hidden md:flex fixed bottom-[240px] right-6 z-[5000] flex-col gap-4 items-end pointer-events-none">
                {calc.surchargeNettoValue > 0 && (
                    <div className="pointer-events-auto w-28 h-24 bg-cyan-900/90 border-2 border-cyan-400 rounded-xl shadow-[0_0_20px_rgba(6,182,212,0.8)] animate-pulse flex flex-col items-center justify-center text-pe-text backdrop-blur-md">
                        <span className="text-2xl mb-1">⚠️</span>
                        <span className="text-[10px] font-black uppercase tracking-widest opacity-80">Achtung</span>
                        <span className="text-[11px] font-bold uppercase text-center mt-0.5 leading-tight text-cyan-100">Spezial<br/>Zuschlag</span>
                    </div>
                )}
                {calc.totalActivatedDevicePrice > 0 && (
                    <div className="pointer-events-auto w-28 h-24 bg-purple-900/90 border-2 border-purple-500 rounded-xl shadow-[0_0_20px_rgba(147,51,234,0.8)] animate-pulse flex flex-col items-center justify-center text-pe-text backdrop-blur-md">
                        <span className="text-2xl mb-1">⚠️</span>
                        <span className="text-[10px] font-black uppercase tracking-widest opacity-80">Achtung</span>
                        <span className="text-[11px] font-bold uppercase text-center mt-0.5 leading-tight text-purple-200">Geräte<br/>aktiv</span>
                    </div>
                )}
                {calc.totalMaterialCost > 0 && (
                    <button 
                        onClick={() => materialRef.current?.scrollIntoView({behavior: 'smooth'})} 
                        className="pointer-events-auto w-28 h-24 bg-yellow-700/90 border-2 border-yellow-400 rounded-xl shadow-[0_0_20px_rgba(202,138,4,0.8)] animate-pulse flex flex-col items-center justify-center text-pe-text cursor-pointer hover:bg-yellow-600 transition-colors backdrop-blur-md"
                    >
                        <span className="text-2xl mb-1">⚠️</span>
                        <span className="text-[10px] font-black uppercase tracking-widest opacity-80">Achtung</span>
                        <span className="text-[11px] font-bold uppercase text-center mt-0.5 leading-tight text-yellow-100">Material<br/>aktiv</span>
                    </button>
                )}
            </div>

            {showBeratungsBarometer && isGodMode && (
                <BeratungsBarometerModal
                    stundenfaktor={stundenfaktor}
                    kalkRuecklage={basisRuecklage}
                    storeCalc={storeCalc}
                    formatCurrency={formatCurrency}
                    initialDemoRate={kalkState.useEchterStundensatz && kalkState.echterStundensatz > 0 ? kalkState.echterStundensatz : stundenfaktor}
                    effectiveSozialabgabenPercent={effectiveSozialabgabenPercent}
                    materialData={materialData}
                    activeMaterialIDs={actMat}
                    onToggleMaterial={toggleMaterial}
                    initialMaterialGramm={inputs.materialGramm || 0}
                    onClose={() => setShowBeratungsBarometer(false)}
                />
            )}

            {/* 💉 Nag-Modal Aufruf */}
            {showNagModal && !kalkState.hasConfirmedRates && (stundenfaktor > 0 || targetMatPreis > 0) && (
                <NagModal 
                    stundenfaktor={stundenfaktor} 
                    targetMatPreis={targetMatPreis} 
                    formatCurrency={formatCurrency}
                    onConfirmMatch={() => {
                        updateKalkState({ hasConfirmedRates: true, useEchterStundensatz: false, useEchterStundensatzMat: false });
                        setShowNagModal(false);
                    }}
                    onSaveCustomRates={(baseVal: number, matVal: number) => {
                        updateKalkState({ 
                            hasConfirmedRates: true,
                            useEchterStundensatz: true,
                            echterStundensatz: baseVal,
                            useEchterStundensatzMat: true,
                            echterStundensatzMat: matVal
                        });
                        setShowNagModal(false);
                    }}
                    onClose={() => setShowNagModal(false)}
                />
            )}

            {showPreislisteModal && <PreislisteModal onClose={() => setShowPreislisteModal(false)} onSave={handleSavePreisliste} calc={calc} inputs={inputs} geraeteData={geraeteDisplayData} />}
            {showPaketpreisModal && (
                <PaketpreisModal
                    draft={paketDraft}
                    onDraftChange={setPaketDraft}
                    onClose={() => setShowPaketpreisModal(false)}
                    onDiscard={() => {
                        setPaketDraft(emptyPaketpreisDraft());
                        clearPaketpreisDraft();
                        setShowPaketpreisModal(false);
                    }}
                    onSave={handleSavePaketpreis}
                    formatCurrency={formatCurrency}
                    current={{
                        name: aktuelleLeistungName,
                        einzelpreisBrutto: Number(inputs.neuerPreis) || 0,
                        dauerMinuten: Number(inputs.bedienzeit) || 0,
                        materialKostenNetto: Number(calc.totalMaterialCost) || 0,
                        materialMenge: Number(inputs.materialGramm) || 0,
                        geraeteKostenNetto: Number(calc.totalActivatedDevicePrice) || 0,
                    }}
                />
            )}
            {showMasterTool && <PreislistenManager onClose={() => setShowMasterTool(false)} />}
            {showPin && ( <div className="fixed inset-0 bg-stone-900/50 dark:bg-black/95 z-[1000000] flex items-center justify-center p-4 backdrop-blur-md"> <div className="bg-pe-card p-8 border border-customBeige/50 rounded-2xl text-center shadow-2xl"> <h3 className="mb-4 text-customBeige font-bold text-lg uppercase tracking-widest">Admin-PIN</h3> <input type="password" onKeyDown={(e: any) => {if(e.key === 'Enter' && e.target.value === '90') {setIsAdmin(true); setShowPin(false);}}} className="editable-field w-32 !text-2xl !bg-pe-input dark:!bg-black" autoFocus /> <div className="mt-3 text-[10px] text-stone-500 dark:text-gray-500 uppercase tracking-widest">Enter zum Bestätigen</div><button onClick={()=>setShowPin(false)} className="block mt-6 text-pe-muted dark:text-gray-400 mx-auto hover:text-pe-text transition-colors underline text-xs">Abbrechen</button> </div> </div> )}
        </div>
    );
}